// ==========================================
// MANUAL MODE - Variables and Functions
// ==========================================

(function() {
  let manualAreas = [];
  let manualAreaCounter = 0;
  let currentShapeType = 'rectangle';
  let currentManualDepth = 3; // Default depth for manual mode
  
  function initManualMode() {
    const addBtn = document.getElementById('add-area-btn');
    const shapeToggleBtns = document.querySelectorAll('.shape-toggle-btn');
    
    // Shape toggle listeners
    shapeToggleBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        shapeToggleBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        currentShapeType = this.dataset.shape;
        
        if (currentShapeType === 'rectangle') {
          document.getElementById('rectangle-inputs').style.display = 'block';
          document.getElementById('circle-inputs').style.display = 'none';
        } else {
          document.getElementById('rectangle-inputs').style.display = 'none';
          document.getElementById('circle-inputs').style.display = 'block';
        }
      });
    });
    
    // Add area button
    if (addBtn) {
      addBtn.addEventListener('click', addManualArea);
    }
    
    // Enter key listeners for inputs
    const lengthInput = document.getElementById('area-length');
    const widthInput = document.getElementById('area-width');
    const diameterInput = document.getElementById('area-diameter');
    
    if (lengthInput) {
      lengthInput.addEventListener('keypress', e => {
        if (e.key === 'Enter') addManualArea();
      });
    }
    if (widthInput) {
      widthInput.addEventListener('keypress', e => {
        if (e.key === 'Enter') addManualArea();
      });
    }
    if (diameterInput) {
      diameterInput.addEventListener('keypress', e => {
        if (e.key === 'Enter') addManualArea();
      });
    }
    
    // Per-area depth bubble listeners (delegated)
    const areasList = document.getElementById('manual-areas-list');
    if (areasList) {
      areasList.addEventListener('click', function(e) {
        if (e.target.classList.contains('depth-bubble')) {
          const areaId = parseInt(e.target.dataset.areaId);
          const newDepth = parseInt(e.target.dataset.depth);
          
          const area = manualAreas.find(a => a.id === areaId);
          if (area) {
            area.depth = newDepth;
            area.cubicYards = calculateCubicYards(area.area, newDepth);
            updateManualUI();
          }
        }
      });
    }
  }
  
  function addManualArea() {
    const nameInput = document.getElementById('area-name');
    let areaSquareFeet;
    
    if (currentShapeType === 'rectangle') {
      const lengthInput = document.getElementById('area-length');
      const widthInput = document.getElementById('area-width');
      
      const length = parseFloat(lengthInput.value);
      const width = parseFloat(widthInput.value);
      
      if (!length || !width || length <= 0 || width <= 0) {
        alert('Please enter valid length and width');
        return;
      }
      
      areaSquareFeet = length * width;
      
      manualAreaCounter++;
      
      const area = {
        id: manualAreaCounter,
        name: nameInput.value.trim() || `Area ${manualAreaCounter}`,
        type: 'rectangle',
        length: length,
        width: width,
        area: areaSquareFeet,
        depth: currentManualDepth,
        cubicYards: calculateCubicYards(areaSquareFeet, currentManualDepth)
      };
      
      manualAreas.push(area);
      
      lengthInput.value = '';
      widthInput.value = '';
      
    } else {
      const diameterInput = document.getElementById('area-diameter');
      
      const diameter = parseFloat(diameterInput.value);
      
      if (!diameter || diameter <= 0) {
        alert('Please enter valid diameter');
        return;
      }
      
      const radius = diameter / 2;
      areaSquareFeet = Math.PI * radius * radius;
      
      manualAreaCounter++;
      
      const area = {
        id: manualAreaCounter,
        name: nameInput.value.trim() || `Area ${manualAreaCounter}`,
        type: 'circle',
        diameter: diameter,
        area: areaSquareFeet,
        depth: currentManualDepth,
        cubicYards: calculateCubicYards(areaSquareFeet, currentManualDepth)
      };
      
      manualAreas.push(area);
      
      diameterInput.value = '';
    }
    
    nameInput.value = '';
    
    updateManualUI();
  }
  
  function calculateCubicYards(areaSquareFeet, depthInches) {
    const depthFeet = depthInches / 12;
    const volumeCubicFeet = areaSquareFeet * depthFeet;
    const volumeCubicYards = volumeCubicFeet / 27;
    return Math.round(volumeCubicYards * 10) / 10;
  }
  
  function deleteManualArea(areaId) {
    const index = manualAreas.findIndex(a => a.id === areaId);
    if (index !== -1) {
      manualAreas.splice(index, 1);
      updateManualUI();
    }
  }
  
  function updateManualUI() {
    const countBadge = document.getElementById('manual-areas-count');
    const areasList = document.getElementById('manual-areas-list');
    const emptyState = document.getElementById('manual-empty-state');
    const estimateCard = document.getElementById('manual-estimate-card');
    const totalAreaEl = document.getElementById('manual-total-area');
    const totalMaterialEl = document.getElementById('manual-total-material');
    
    if (!countBadge) return;
    
    countBadge.textContent = `${manualAreas.length} area${manualAreas.length !== 1 ? 's' : ''}`;
    
    if (manualAreas.length === 0) {
      areasList.innerHTML = '';
      emptyState.style.display = 'block';
      estimateCard.style.display = 'none';
    } else {
      emptyState.style.display = 'none';
      estimateCard.style.display = 'block';
      
      areasList.innerHTML = '';
      manualAreas.forEach(area => {
        const areaItem = document.createElement('div');
        areaItem.className = 'manual-area-item';
        
        let dimensionText = '';
        if (area.type === 'rectangle') {
          dimensionText = `${area.length.toFixed(1)} × ${area.width.toFixed(1)} ft`;
        } else {
          dimensionText = `⌀ ${area.diameter.toFixed(1)} ft`;
        }
        
        areaItem.innerHTML = `
          <div class="manual-area-header">
            <div class="manual-area-name">${area.name}</div>
            <button class="manual-area-delete" onclick="window.deleteManualArea(${area.id})">×</button>
          </div>
          <div class="manual-area-summary">
            <span class="manual-area-dims">${dimensionText}</span>
            <span class="manual-area-sep">·</span>
            <span class="manual-area-sqft">${area.area.toFixed(0)} sq ft</span>
            <span class="manual-area-sep">·</span>
            <span class="manual-area-material">${area.cubicYards.toFixed(1)} cu yd</span>
          </div>
          <div class="manual-area-depth-control">
            <label class="manual-area-depth-label">DEPTH</label>
            <div class="depth-bubbles" data-area-id="${area.id}">
              ${[1, 2, 3, 4, 5, 6].map(depth => `
                <button 
                  class="depth-bubble ${depth === area.depth ? 'active' : ''}" 
                  data-depth="${depth}"
                  data-area-id="${area.id}"
                >
                  ${depth}"
                </button>
              `).join('')}
            </div>
          </div>
        `;
        areasList.appendChild(areaItem);
      });
      
      const totalArea = manualAreas.reduce((sum, a) => sum + a.area, 0);
      const totalMaterial = manualAreas.reduce((sum, a) => sum + a.cubicYards, 0);
      
      totalAreaEl.textContent = totalArea.toFixed(1);
      totalMaterialEl.textContent = totalMaterial.toFixed(1);
    }
  }
  
  // Expose delete function globally
  window.deleteManualArea = deleteManualArea;
  
  // Initialize manual mode when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initManualMode);
  } else {
    initManualMode();
  }
})();

// ==========================================
// SATELLITE MODE - All existing functionality
// ==========================================

(function() {
  const API_KEY = 'AIzaSyA6JsrhIT0WNgBgGLvoPe4qHZSm3P8re1Q';
  
  // Google Apps Script Web App URL - REPLACE WITH YOUR DEPLOYED URL
  const APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyTliuXKddJo0dPxhPruDtruc8KvA8Jf1WS2pZ8xNXd3BMnukA1LOXlM7Y_oCLWYsnCFw/exec';
  
  // URL parameter handling for restoration
  let isRestoringFromURL = false;
  let urlParamType = null; // 'session', 'data', or 'admin'
  let urlSessionId = null;
  let isRestoringFromLocalStorage = false; // NEW: Track localStorage restoration
  let localStorageData = null; // NEW: Store parsed localStorage data
  
  // Phase 2: Return visit tracking
  let parentSessionId = null;
  let isReturnVisit = false;
  let initialShapesState = null; // Track initial state to detect changes
  let isAddressChangeSession = false; // Track if this session started from address change: false, 'new', or 'return'
  let hasLoggedFirstChange = false; // Track if we've saved first change (for immediate save on first edit)
  let currentVisitNumber = 1; // Track visit number for this browser session (not calculated by row count)
  
  // Phase 3: Email persistence and exit handling
  let userEmail = null; // Email for current parent family
  let userMarketingOptIn = true; // Marketing opt-in state (default true)
  let emailHasOptedInBefore = false; // Phase 6: Track if email has opted in before
  
  // Phase 3.3: Auto-save system (Google Docs-style)
  let autoSaveTimer = null;
  let periodicSaveTimer = null;
  const AUTO_SAVE_DELAY = 2000; // 2 seconds after last action
  const PERIODIC_SAVE_INTERVAL = 30000; // 30 seconds
  let lastSaveTime = 0;
  let hasUnsavedChanges = false;
  
  // Phase 4: Admin mode tracking
  let isAdminMode = false;
  
  let map;
  let geocoder;
  let autocomplete;
  let areas = [];
  let areaCounter = 0;
  let activeTool = null; // Start with no active tool until address is entered
  let drawingMode = false;
  
  // Session tracking
  let sessionId = null;
  let currentAddress = '';
  
  // Undo history - stores last 5 actions with full state snapshots
  let undoHistory = [];
  const MAX_UNDO_HISTORY = 5;
  
  // Touch device detection
  const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  const isMobile = window.innerWidth <= 1024; // Includes iPads
  
  // Mobile tap vs drag detection
  let touchStartPos = null;
  let touchStartTime = 0;
  let hasMoved = false;
  
  // Drawing variables
  let isDrawing = false;
  let startPoint = null;
  let previewShape = null;
  let mouseDownListener = null;
  let mouseMoveListener = null;
  let mouseUpListener = null;
  
  // Selection and resize variables
  let selectedArea = null;
  let resizeHandles = [];
  let radiusLine = null;
  let rotationHandle = null;
  let rotationLine = null;
  let preModificationState = null; // Track state before modifications for undo
  
  // Instruction System
  let currentInstructionState = 'initial';
  let isResizing = false;
  let isRotating = false;
  
  // Mobile drawer state
  let drawerState = 'hidden'; // 'hidden', 'collapsed', 'expanded'
  
  // Track last searched address for location found instruction
  let lastAddress = '';
  
  // SVG Icons for instructions
  const instructionIcons = {
    house: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>`,
    hand: null, // Will use theme editor uploaded icon or fallback SVG
    circle: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/>
    </svg>`,
    rectangle: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
    </svg>`,
    resize: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="15 3 21 3 21 9"/>
      <polyline points="9 21 3 21 3 15"/>
      <line x1="21" y1="3" x2="14" y2="10"/>
      <line x1="3" y1="21" x2="10" y2="14"/>
    </svg>`,
    rotate: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21.5 2v6h-6"/>
      <path d="M21 12a9 9 0 1 1-2.63-6.37L21.5 8"/>
    </svg>`,
    mapPin: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>`
  };
  
  // Screen navigation - satellite back button
  const backBtn = document.getElementById('satellite-back-btn');
  
  if (backBtn) {
    backBtn.addEventListener('click', function() {
      console.log('🔙 Back button clicked');
      console.log('   areas.length:', areas.length);
      console.log('   currentAddress:', currentAddress);
      console.log('   isAdminMode:', isAdminMode);
      
      // PHASE 4: Admin mode - skip exit warning, just exit
      if (isAdminMode) {
        console.log('   → Admin mode, exiting without modal');
        
        // Clear localStorage to prevent auto-restore on refresh
        localStorage.removeItem('calcData');
        console.log('📦 Cleared localStorage (admin exit)');
        
        if (window.showSelectionScreen) {
          window.showSelectionScreen();
        }
        
        if (isMobile) {
          document.body.classList.remove('calculator-active');
        }
        return;
      }
      
      // PHASE 3: Check if there's anything to save
      // For fresh sessions: areas.length > 0 means they drew something
      // For return sessions: hasChangesBeenMade() detects modifications
      const hasDrawnShapes = areas.length > 0 && currentAddress;
      const hasModifications = hasChangesBeenMade();
      
      console.log('   hasDrawnShapes:', hasDrawnShapes ? true : false, '(areas.length > 0 && currentAddress)');
      console.log('   hasModifications:', hasModifications);
      
      if (hasDrawnShapes || hasModifications) {
        // Show exit warning modal with email option
        console.log('   → Showing exit modal');
        showExitWarningModal();
      } else {
        // No shapes drawn, no changes - exit normally without saving
        console.log('   → No shapes/changes, exiting normally');
        
        // Clear localStorage to prevent auto-restore on refresh
        localStorage.removeItem('calcData');
        console.log('📦 Cleared localStorage (no shapes to preserve)');
        
        if (window.showSelectionScreen) {
          window.showSelectionScreen();
        }
        
        // Mobile: Disable full-screen mode and unlock body scroll
        if (isMobile) {
          document.body.classList.remove('calculator-active');
        }
      }
    });
  } else {
    console.log('⚠️ satellite-back-btn not found!');
  }
  
  // Mobile drawer toggle - set up regardless of initial mobile state
  const drawerToggle = document.getElementById('drawer-toggle');
  const sidebar = document.getElementById('estimate-sidebar');
  
  if (drawerToggle && sidebar) {
    drawerToggle.addEventListener('click', function() {
      if (!isMobile) return; // Only function on mobile
      
      if (drawerState === 'collapsed') {
        drawerState = 'expanded';
        sidebar.classList.remove('drawer-collapsed');
        sidebar.classList.add('drawer-expanded');
      } else if (drawerState === 'expanded') {
        drawerState = 'collapsed';
        sidebar.classList.remove('drawer-expanded');
        sidebar.classList.add('drawer-collapsed');
      }
    });
  }
  
  function updateDrawerState() {
    if (!isMobile) return;
    
    const sidebar = document.getElementById('estimate-sidebar');
    
    if (!sidebar) return;
    
    if (areas.length === 0) {
      // Hide drawer when no areas
      drawerState = 'hidden';
      sidebar.classList.remove('drawer-collapsed', 'drawer-expanded');
      sidebar.classList.add('drawer-hidden');
    } else {
      // Show collapsed drawer when areas exist (only if currently hidden)
      if (drawerState === 'hidden') {
        drawerState = 'collapsed';
        sidebar.classList.remove('drawer-hidden', 'drawer-expanded');
        sidebar.classList.add('drawer-collapsed');
      }
    }
  }
  
  function updateDrawerTotals() {
    if (!isMobile) return;
    
    let totalArea = 0;
    let totalCubicYards = 0;
    
    areas.forEach(areaData => {
      if (areaData.measurements) {
        totalArea += areaData.measurements.area;
        totalCubicYards += areaData.measurements.cubicYards;
      }
    });
    
    const drawerAreaEl = document.getElementById('drawer-total-area');
    const drawerMulchEl = document.getElementById('drawer-total-mulch');
    
    if (drawerAreaEl) {
      drawerAreaEl.textContent = totalArea > 0 
        ? `${totalArea.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} sq ft`
        : '0 sq ft';
    }
    
    if (drawerMulchEl) {
      drawerMulchEl.textContent = totalCubicYards > 0
        ? `${totalCubicYards.toFixed(1)} cu yd`
        : '0 cu yd';
    }
  }
  
  function updateInstruction(state, data = {}) {
    const box = document.getElementById('instruction-box');
    const icon = document.getElementById('instruction-icon');
    const heading = document.getElementById('instruction-heading');
    const subtext = document.getElementById('instruction-subtext');
    
    if (!box || !icon || !heading || !subtext) return;
    
    currentInstructionState = state;
    let instructionData = getInstructionData(state, data);
    
    // Fade out
    box.classList.remove('show');
    
    setTimeout(() => {
      // Update content
      heading.textContent = instructionData.heading;
      subtext.textContent = instructionData.subtext;
      
      // Update icon
      if (instructionData.icon === 'hand') {
        // Use theme editor uploaded icon or fallback
        const panToolBtn = document.getElementById('tool-pan');
        if (panToolBtn) {
          const imgElement = panToolBtn.querySelector('img');
          const svgElement = panToolBtn.querySelector('svg');
          
          if (imgElement) {
            // Theme editor icon exists
            icon.innerHTML = `<img src="${imgElement.src}" alt="Hand tool" style="width: 24px; height: 24px;">`;
          } else if (svgElement) {
            // Fallback SVG
            icon.innerHTML = svgElement.outerHTML;
          }
        }
      } else {
        icon.innerHTML = instructionIcons[instructionData.icon] || '';
      }
      
      // Update style
      box.className = 'instruction-box ' + instructionData.style;
      
      // Fade in
      setTimeout(() => {
        box.classList.add('show');
      }, 50);
    }, 150);
  }
  
  function getInstructionData(state, data = {}) {
    const instructions = {
      initial: {
        heading: "Let's find your property",
        subtext: "Type your address and we'll zoom right in",
        icon: 'house',
        style: 'green'
      },
      locationFound: {
        heading: "Location found",
        subtext: "Your property has been located",
        icon: 'mapPin',
        style: 'green'
      },
      addressFound: {
        heading: "Ready to measure?",
        subtext: "Pick a drawing tool from the left to get started",
        icon: 'hand',
        style: 'green'
      },
      circleSelected: {
        heading: isMobile ? "Tap to place shape" : "Click & drag outward",
        subtext: "Great for tree rings and curved garden beds",
        icon: 'circle',
        style: 'blue'
      },
      rectangleSelected: {
        heading: isMobile ? "Tap to place shape" : "Click & drag to draw",
        subtext: "Perfect for beds, patios, and walkways",
        icon: 'rectangle',
        style: 'red'
      },
      shapePlaced: {
        heading: "Click a shape to edit",
        subtext: "Resize a shape to fit your area",
        icon: 'hand',
        style: 'green'
      },
      rectangleActive: {
        heading: "Shape selected!",
        subtext: "Drag center to move • Corners/edges to resize • Top circle to rotate",
        icon: 'resize',
        style: 'red'
      },
      circleActive: {
        heading: "Circle selected!",
        subtext: "Drag center to move • Edge handle to resize",
        icon: 'circle',
        style: 'blue'
      },
      resizing: {
        heading: "Sizing it up...",
        subtext: "Looking good! Release when ready",
        icon: 'resize',
        style: 'green'
      },
      rotating: {
        heading: "Rotating...",
        subtext: "Spin it to match your angle",
        icon: 'rotate',
        style: 'green'
      }
    };
    
    return instructions[state] || instructions.initial;
  }
  
  function showInstructionBox() {
    const box = document.getElementById('instruction-box');
    if (box) {
      box.style.display = 'flex';
      setTimeout(() => box.classList.add('show'), 50);
    }
  }
  
  function hideInstructionBox() {
    const box = document.getElementById('instruction-box');
    if (box) {
      box.classList.remove('show');
      setTimeout(() => box.style.display = 'none', 300);
    }
  }
  
  // SESSION MANAGEMENT
  function checkURLParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('admin')) {
      urlParamType = 'admin';
      urlSessionId = urlParams.get('admin');
      isRestoringFromURL = true;
      isAdminMode = true; // PHASE 4: Enable admin mode
      console.log('Found admin parameter:', urlSessionId, '(Admin Mode)');
    } else if (urlParams.has('session')) {
      urlParamType = 'session';
      urlSessionId = urlParams.get('session');
      isRestoringFromURL = true;
      console.log('Found session parameter:', urlSessionId);
    } else if (urlParams.has('data')) {
      urlParamType = 'data';
      isRestoringFromURL = true;
      console.log('Found data parameter (legacy)');
    }
  }
  
  async function initializeSession() {
    // Check if we're loading from a URL first
    checkURLParameters();
    
    if (isRestoringFromURL) {
      // PHASE 2: Return visit - create NEW session, track parent
      parentSessionId = urlSessionId; // Temporary - will be resolved in restoreSessionFromURL
      isReturnVisit = true;
      
      // Generate brand NEW session ID for this return visit
      sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('calcSessionId', sessionId);
      
      console.log('Return visit detected! New session:', sessionId, 'Parent (temp):', parentSessionId);
    } else {
      // Normal session initialization
      sessionId = localStorage.getItem('calcSessionId');
      if (!sessionId) {
        sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('calcSessionId', sessionId);
      }
      
      // Try to load saved data from localStorage
      loadFromLocalStorage();
      
      // Load email if available (for same-session re-entry)
      await loadUserEmail();
    }
  }
  
  function saveToLocalStorage() {
    const data = {
      address: currentAddress,
      areas: areas.map(a => ({
        id: a.id,
        type: a.type,
        customName: a.customName,
        depth: a.depth,
        rotation: a.rotation,
        measurements: a.measurements,
        bounds: a.type === 'rectangle' ? (typeof a.shape.getPath === 'function' ? 
          { corners: a.shape.getPath().getArray().map(c => ({ lat: c.lat(), lng: c.lng() })) } :
          { ne: { lat: a.shape.getBounds().getNorthEast().lat(), lng: a.shape.getBounds().getNorthEast().lng() },
            sw: { lat: a.shape.getBounds().getSouthWest().lat(), lng: a.shape.getBounds().getSouthWest().lng() } }
        ) : null,
        center: a.type === 'circle' ? { lat: a.shape.getCenter().lat(), lng: a.shape.getCenter().lng() } : null,
        radius: a.type === 'circle' ? a.shape.getRadius() : null
      })),
      areaCounter: areaCounter
    };
    localStorage.setItem('calcData', JSON.stringify(data));
  }
  
  function loadFromLocalStorage() {
    const savedData = localStorage.getItem('calcData');
    if (!savedData) {
      console.log('No saved localStorage data found');
      return;
    }
    
    try {
      const data = JSON.parse(savedData);
      if (data.address && data.areas && data.areas.length > 0) {
        // We have saved data - flag it for restoration
        console.log('✓ Found saved localStorage data:', data.areas.length, 'shapes at', data.address);
        isRestoringFromLocalStorage = true;
        localStorageData = data;
      } else {
        console.log('localStorage data exists but incomplete (no address or areas)');
      }
    } catch (e) {
      console.error('Error parsing localStorage data:', e);
      // Clear corrupted data
      localStorage.removeItem('calcData');
    }
  }
  
  // PHASE 3.3: AUTO-SAVE FUNCTIONS
  
  /**
   * Trigger auto-save with debouncing
   * Called after every user action (shape added/moved/resized/deleted, etc.)
   */
  function triggerAutoSave() {
    // Mark that we have unsaved changes
    hasUnsavedChanges = true;
    
    // OPTION A: MILESTONE 2 - Check if this is first change since restoration
    if (isReturnVisit && !hasLoggedFirstChange && hasChangesBeenMade()) {
      console.log('📌 MILESTONE: First change detected - saving immediately with made_changes source');
      hasLoggedFirstChange = true;
      // Save immediately (no timer)
      performAutoSave();
      return;
    }
    
    // Clear existing timer
    if (autoSaveTimer) {
      clearTimeout(autoSaveTimer);
    }
    
    // Set new timer - save after 2 seconds of inactivity
    autoSaveTimer = setTimeout(() => {
      performAutoSave();
    }, AUTO_SAVE_DELAY);
  }
  
  /**
   * Perform the actual auto-save
   * Uses the proven captureAndSendData() function
   */
  function performAutoSave() {
    // PHASE 4: Block auto-save in admin mode
    if (isAdminMode) {
      hasUnsavedChanges = false;
      return;
    }
    
    // ENHANCEMENT #2: Save if we have an address (shapes optional)
    if (!currentAddress) {
      hasUnsavedChanges = false;
      return;
    }
    
    // Don't save too frequently (throttle to once per 5 seconds minimum)
    const now = Date.now();
    if (now - lastSaveTime < 5000) {
      console.log('Auto-save throttled - too soon since last save');
      return;
    }
    
    console.log('🔄 Auto-saving...');
    lastSaveTime = now;
    hasUnsavedChanges = false;
    
    // Use existing proven save function - pass userEmail if available (don't send email notification)
    captureAndSendData(false, userEmail);
  }
  
  /**
   * Start periodic auto-save backup timer
   * Saves every 30 seconds as a safety net
   */
  function startPeriodicAutoSave() {
    if (periodicSaveTimer) {
      clearInterval(periodicSaveTimer);
    }
    
    periodicSaveTimer = setInterval(() => {
      // ENHANCEMENT #2: Save if there are unsaved changes and an address
      if (hasUnsavedChanges && currentAddress) {
        console.log('⏰ Periodic auto-save triggered');
        performAutoSave();
      }
    }, PERIODIC_SAVE_INTERVAL);
  }
  
  /**
   * Stop periodic auto-save
   */
  function stopPeriodicAutoSave() {
    if (periodicSaveTimer) {
      clearInterval(periodicSaveTimer);
      periodicSaveTimer = null;
    }
  }
  
  // END PHASE 3.3 AUTO-SAVE FUNCTIONS
  
  function captureAndSendData(includeEmail = false, userEmailParam = null, marketingOptIn = false) {
    // PHASE 4: Block all saves in admin mode
    if (isAdminMode) {
      console.log('Admin mode: Save blocked');
      return;
    }
    
    // ENHANCEMENT #2: Allow saving with just address (no shapes required)
    if (!currentAddress) {
      console.log('No address to capture');
      return;
    }
    
    // PHASE 3: Save email if provided
    if (includeEmail && userEmailParam) {
      saveUserEmail(userEmailParam);
    }
    
    const numRectangles = areas.filter(a => a.type === 'rectangle').length;
    const numCircles = areas.filter(a => a.type === 'circle').length;
    
    let totalArea = 0;
    let totalCubicYards = 0;
    areas.forEach(areaData => {
      if (areaData.measurements) {
        totalArea += areaData.measurements.area;
        totalCubicYards += areaData.measurements.cubicYards;
      }
    });
    
    // Encode shape data for "View Your Map" link
    const shapesForUrl = areas.map(a => ({
      id: a.id,
      type: a.type,
      customName: a.customName,
      depth: a.depth,
      rotation: a.rotation,
      measurements: a.measurements,
      bounds: a.type === 'rectangle' ? (typeof a.shape.getPath === 'function' ? 
        { corners: a.shape.getPath().getArray().map(c => ({ lat: c.lat(), lng: c.lng() })) } :
        { ne: { lat: a.shape.getBounds().getNorthEast().lat(), lng: a.shape.getBounds().getNorthEast().lng() },
          sw: { lat: a.shape.getBounds().getSouthWest().lat(), lng: a.shape.getBounds().getSouthWest().lng() } }
      ) : null,
      center: a.type === 'circle' ? { lat: a.shape.getCenter().lat(), lng: a.shape.getCenter().lng() } : null,
      radius: a.type === 'circle' ? a.shape.getRadius() : null
    }));
    
    const urlData = {
      address: currentAddress,
      areas: shapesForUrl,
      areaCounter: areaCounter
    };
    // Use short session-based link instead of long data-encoded link
    const viewMapLink = window.location.origin + window.location.pathname + '?session=' + sessionId;
    
    // ENHANCEMENT: Determine source based on session type and user actions
    // Check address change FIRST (takes priority over return visit status)
    let source = 'new';
    if (isAddressChangeSession === 'return') {
      source = 'email_return_address_change';
    } else if (isAddressChangeSession === 'new') {
      source = 'address_change_new';
    } else if (isReturnVisit) {
      // User came from email link - check if they made changes
      if (hasChangesBeenMade()) {
        source = 'email_return_made_changes';
      } else {
        source = 'email_return_view_only';
      }
    }
    
    const payload = {
      sessionId: sessionId,
      timestamp: new Date().toISOString(),
      address: currentAddress,
      numAreas: areas.length,
      numRectangles: numRectangles,
      numCircles: numCircles,
      totalArea: Math.round(totalArea),
      totalMaterial: totalCubicYards.toFixed(1),
      shapesData: JSON.stringify(shapesForUrl),
      viewMapLink: viewMapLink,
      hasEmail: !!(userEmailParam && userEmailParam.trim()),
      email: userEmailParam || '',
      sendNotification: includeEmail, // Only true when user explicitly clicks "Email Me"
      parentSessionId: parentSessionId || null,
      visitNumber: currentVisitNumber, // Send explicit visit number from JS (not calculated by Apps Script)
      source: source,
      marketingOptIn: marketingOptIn
    };
    
    // Send to Google Apps Script
    fetch(APPS_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    })
    .then(() => {
      console.log('Data sent to Google Sheets');
      if (includeEmail) {
        showEmailSuccessMessage();
      }
    })
    .catch((error) => {
      console.error('Error sending data:', error);
    });
  }
  
  function showEmailSuccessMessage() {
    alert('✓ Estimate sent to your email! Check your inbox for the "View Your Map" link.');
  }
  
  function showEmailModal() {
    const modal = document.getElementById('email-modal');
    if (modal) {
      const emailInputField = modal.querySelector('#email-input-field');
      const marketingOptinCheckbox = modal.querySelector('#email-marketing-optin');
      const optinContainer = modal.querySelector('.email-modal-optin');
      
      // Pre-fill email if user has one
      if (emailInputField) {
        emailInputField.value = userEmail || '';
      }
      
      // Use cached opt-in status (already pre-fetched)
      if (emailInputField && emailInputField.value && emailHasOptedInBefore) {
        // Hide checkbox if email has opted in before
        if (optinContainer) {
          optinContainer.style.display = 'none';
        }
      } else if (optinContainer) {
        // Show checkbox and pre-fill state
        optinContainer.style.display = 'block';
        if (marketingOptinCheckbox) {
          marketingOptinCheckbox.checked = userMarketingOptIn;
        }
      }
      
      modal.style.display = 'flex';
      // Focus email input
      setTimeout(() => {
        if (emailInputField) {
          emailInputField.focus();
          // If pre-filled, move cursor to end
          if (emailInputField.value) {
            emailInputField.setSelectionRange(emailInputField.value.length, emailInputField.value.length);
          }
        }
      }, 100);
    }
  }
  
  function hideEmailModal() {
    const modal = document.getElementById('email-modal');
    if (modal) {
      modal.style.display = 'none';
    }
  }
  
  function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
  
  // PHASE 6: Check if email has opted in before
  async function checkEmailOptInStatus(email) {
    if (!email) return false;
    
    try {
      const response = await fetch(`${APPS_SCRIPT_URL}?checkOptIn=${encodeURIComponent(email)}`);
      const result = await response.json();
      
      if (result.status === 'success') {
        return result.hasOptedIn;
      }
      return false;
    } catch (error) {
      console.error('Error checking email opt-in status:', error);
      return false;
    }
  }
  
  // PHASE 6: Pre-fetch and cache opt-in status for loaded email
  async function prefetchOptInStatus(email) {
    if (!email) {
      emailHasOptedInBefore = false;
      return;
    }
    
    const hasOptedIn = await checkEmailOptInStatus(email);
    emailHasOptedInBefore = hasOptedIn;
    console.log('Pre-fetched opt-in status for email:', email, '→', hasOptedIn);
  }
  
  // PHASE 3: Exit Warning Modal Functions
  // PHASE 3 + ENHANCEMENT 2: Exit Warning Modal Functions
  function showExitWarningModal() {
    console.log('📧 showExitWarningModal() called');
    const modal = document.getElementById('exit-warning-modal');
    console.log('   Modal element:', modal ? 'FOUND' : 'NOT FOUND');
    if (!modal) {
      console.log('   ❌ Modal element does not exist! Cannot show modal.');
      return;
    }
    
    const emailInputField = modal.querySelector('#exit-email-input');
    const marketingOptinCheckbox = modal.querySelector('#exit-marketing-optin');
    const optinContainer = modal.querySelector('.exit-modal-optin');
    const subtitle = modal.querySelector('#exit-modal-subtitle');
    
    console.log('   Email input:', emailInputField ? 'FOUND' : 'NOT FOUND');
    console.log('   Current modal display:', modal.style.display);
    
    // ENHANCEMENT 2: Always show email input, pre-filled if user has email
    if (emailInputField) {
      emailInputField.value = userEmail || '';
    }
    
    // PHASE 6: Use cached opt-in status (already pre-fetched)
    if (emailInputField && emailInputField.value && emailHasOptedInBefore) {
      // Hide checkbox if email has opted in before
      if (optinContainer) {
        optinContainer.style.display = 'none';
        console.log('   Email has opted in before - hiding checkbox');
      }
    } else if (optinContainer) {
      // Show checkbox and pre-fill state
      optinContainer.style.display = 'block';
      if (marketingOptinCheckbox) {
        marketingOptinCheckbox.checked = userMarketingOptIn;
        console.log('   Pre-filled marketing opt-in:', userMarketingOptIn);
      }
    }
    
    // ENHANCEMENT 2: Show/hide subtitle based on whether it's a return visit
    if (subtitle) {
      if (isReturnVisit) {
        subtitle.style.display = 'none';
      } else {
        subtitle.style.display = 'block';
      }
    }
    
    modal.style.display = 'flex';
    console.log('   ✅ Modal display set to: flex');
    
    // Focus email input
    if (emailInputField) {
      setTimeout(() => {
        emailInputField.focus();
        // If pre-filled, move cursor to end
        if (emailInputField.value) {
          emailInputField.setSelectionRange(emailInputField.value.length, emailInputField.value.length);
        }
      }, 100);
    }
  }
  
  function hideExitWarningModal() {
    const modal = document.getElementById('exit-warning-modal');
    if (modal) {
      modal.style.display = 'none';
    }
  }
  
  function handleExitWithEmail() {
    const modal = document.getElementById('exit-warning-modal');
    const emailInputField = modal.querySelector('#exit-email-input');
    const marketingOptinCheckbox = modal.querySelector('#exit-marketing-optin');
    
    // ENHANCEMENT 2: Always get email from input field (it's pre-filled if they had one)
    let emailToSend = '';
    if (emailInputField) {
      emailToSend = emailInputField.value.trim();
    }
    
    if (!emailToSend) {
      alert('Please enter your email address');
      return;
    }
    
    if (!isValidEmail(emailToSend)) {
      alert('Please enter a valid email address');
      return;
    }
    
    // PHASE 6: Get marketing opt-in state - force TRUE if email has opted in before
    let marketingOptIn;
    if (emailHasOptedInBefore) {
      marketingOptIn = true; // Force TRUE if email has opted in before
    } else {
      marketingOptIn = marketingOptinCheckbox ? marketingOptinCheckbox.checked : false;
    }
    
    // Save the email and marketing opt-in (updates if changed)
    saveUserEmail(emailToSend, marketingOptIn);
    
    // Send data with email and marketing opt-in
    captureAndSendData(true, emailToSend, marketingOptIn);
    
    // Hide modal and exit
    hideExitWarningModal();
    
    // Exit calculator - return to selection screen (state persists)
    setTimeout(() => {
      // Clear localStorage after successful save
      localStorage.removeItem('calcData');
      console.log('📦 Cleared localStorage (shapes saved to server)');
      
      if (window.showSelectionScreen) {
        window.showSelectionScreen();
      }
      
      if (isMobile) {
        document.body.classList.remove('calculator-active');
      }
    }, 100);
  }
  
  function handleExitWithoutEmail() {
    // Save if there are any areas drawn (fresh or modified)
    if ((areas.length > 0 && currentAddress) || hasChangesBeenMade()) {
      captureAndSendData(false, userEmail);
    }
    
    // Hide modal and exit
    hideExitWarningModal();
    
    // Clear localStorage to prevent auto-restore on refresh
    localStorage.removeItem('calcData');
    console.log('📦 Cleared localStorage (exiting without email)');
    
    // Exit calculator - return to selection screen
    if (window.showSelectionScreen) {
      window.showSelectionScreen();
    }
    
    if (isMobile) {
      document.body.classList.remove('calculator-active');
    }
  }
  
  // PHASE 2: Change detection functions
  function captureInitialState() {
    initialShapesState = {
      numAreas: areas.length,
      numRectangles: areas.filter(a => a.type === 'rectangle').length,
      numCircles: areas.filter(a => a.type === 'circle').length,
      areaIds: areas.map(a => a.id).sort(),
      depths: areas.map(a => ({ id: a.id, depth: a.depth }))
    };
    console.log('Initial state captured:', initialShapesState);
  }
  
  function hasChangesBeenMade() {
    if (!initialShapesState) return false;
    
    const currentNumAreas = areas.length;
    const currentNumRectangles = areas.filter(a => a.type === 'rectangle').length;
    const currentNumCircles = areas.filter(a => a.type === 'circle').length;
    const currentAreaIds = areas.map(a => a.id).sort();
    
    // Check if number of shapes changed
    if (currentNumAreas !== initialShapesState.numAreas) return true;
    if (currentNumRectangles !== initialShapesState.numRectangles) return true;
    if (currentNumCircles !== initialShapesState.numCircles) return true;
    
    // Check if shape IDs changed (shapes added/removed)
    if (JSON.stringify(currentAreaIds) !== JSON.stringify(initialShapesState.areaIds)) return true;
    
    // Check if depths changed
    for (let area of areas) {
      const initialDepth = initialShapesState.depths.find(d => d.id === area.id);
      if (initialDepth && initialDepth.depth !== area.depth) return true;
    }
    
    return false;
  }
  
  // PHASE 3: Email Persistence Functions
  async function loadUserEmail() {
    let foundEmail = null;
    let foundOptIn = true;
    
    // Priority 1: Try current sessionId
    const sessionKey = `calcEmail_${sessionId}`;
    const sessionOptInKey = `calcOptIn_${sessionId}`;
    foundEmail = localStorage.getItem(sessionKey);
    if (foundEmail) {
      userEmail = foundEmail;
      const optInValue = localStorage.getItem(sessionOptInKey);
      userMarketingOptIn = optInValue !== null ? optInValue === 'true' : true;
      console.log('Loaded email from current session:', userEmail);
      await prefetchOptInStatus(userEmail); // Pre-fetch opt-in status
      return;
    }
    
    // Priority 2: Try parent sessionId (for return visits)
    if (parentSessionId) {
      const parentKey = `calcEmail_${parentSessionId}`;
      const parentOptInKey = `calcOptIn_${parentSessionId}`;
      foundEmail = localStorage.getItem(parentKey);
      if (foundEmail) {
        userEmail = foundEmail;
        const optInValue = localStorage.getItem(parentOptInKey);
        userMarketingOptIn = optInValue !== null ? optInValue === 'true' : true;
        console.log('Loaded email from parent session:', userEmail);
        await prefetchOptInStatus(userEmail); // Pre-fetch opt-in status
        return;
      }
    }
    
    // Priority 3: Try last known email (fallback)
    foundEmail = localStorage.getItem('calcEmail_last');
    if (foundEmail) {
      userEmail = foundEmail;
      const optInValue = localStorage.getItem('calcOptIn_last');
      userMarketingOptIn = optInValue !== null ? optInValue === 'true' : true;
      console.log('Loaded email from last session:', userEmail);
      await prefetchOptInStatus(userEmail); // Pre-fetch opt-in status
      return;
    }
    
    // No email found
    userEmail = null;
    userMarketingOptIn = true; // Reset to default
    emailHasOptedInBefore = false;
    console.log('No email found in localStorage');
  }
  
  function saveUserEmail(email, marketingOptIn = true) {
    if (!email) return;
    
    userEmail = email;
    userMarketingOptIn = marketingOptIn;
    
    // Store with current sessionId (for same-session re-entry)
    const sessionKey = `calcEmail_${sessionId}`;
    const sessionOptInKey = `calcOptIn_${sessionId}`;
    localStorage.setItem(sessionKey, email);
    localStorage.setItem(sessionOptInKey, marketingOptIn.toString());
    
    // ALSO store with parentSessionId if available (for family tracking)
    if (parentSessionId) {
      const parentKey = `calcEmail_${parentSessionId}`;
      const parentOptInKey = `calcOptIn_${parentSessionId}`;
      localStorage.setItem(parentKey, email);
      localStorage.setItem(parentOptInKey, marketingOptIn.toString());
      console.log('Saved email to parent session:', parentSessionId);
    }
    
    // Store globally for easy re-entry (last known email)
    localStorage.setItem('calcEmail_last', email);
    localStorage.setItem('calcOptIn_last', marketingOptIn.toString());
    
    console.log('Saved email to localStorage:', email);
  }
  
  function clearUserEmail() {
    userEmail = null;
    userMarketingOptIn = true; // Reset to default
    
    // Only clear if we have a parent session
    if (parentSessionId) {
      const storageKey = `calcEmail_${parentSessionId}`;
      const optInKey = `calcOptIn_${parentSessionId}`;
      
      localStorage.removeItem(storageKey);
      localStorage.removeItem(optInKey);
      
      console.log('Cleared email and marketing opt-in from localStorage');
    }
  }
  
  // RESTORATION FUNCTIONS - Phase 1
  async function fetchSessionFromSheet(sessionId, isAdmin = false) {
    try {
      // PHASE 5: Use correct parameter name based on link type
      const paramName = isAdmin ? 'admin' : 'session';
      const response = await fetch(`${APPS_SCRIPT_URL}?${paramName}=${sessionId}`);
      const result = await response.json();
      
      if (result.status === 'success' && result.data) {
        console.log('Successfully fetched session data:', result.data);
        // PHASE 5: Return full result including redirect metadata
        return {
          data: result.data,
          redirected: result.redirected || false,
          originalSessionId: result.originalSessionId || null
        };
      } else {
        console.error('Session not found or error:', result.message);
        return null;
      }
    } catch (error) {
      console.error('Error fetching session:', error);
      return null;
    }
  }
  
  async function restoreSessionFromURL() {
    if (!isRestoringFromURL) return;
    
    // Show loading overlay
    const overlay = document.getElementById('restoration-overlay');
    if (overlay) {
      overlay.style.display = 'flex';
    }
    
    console.log('Starting restoration...', urlParamType, urlSessionId);
    
    let sessionData = null;
    let fetchResult = null;
    
    if (urlParamType === 'session' || urlParamType === 'admin') {
      // Fetch from Google Sheet
      console.log('Fetching session from sheet...');
      const isAdmin = (urlParamType === 'admin');
      fetchResult = await fetchSessionFromSheet(urlSessionId, isAdmin);
      console.log('Fetch complete:', fetchResult);
      
      if (fetchResult) {
        sessionData = fetchResult.data;
        
        // PHASE 5: Handle address-based redirect (only for non-admin links)
        if (fetchResult.redirected && !isAdmin) {
          console.log('📍 Address-based redirect detected!');
          console.log('Original session:', fetchResult.originalSessionId);
          console.log('Latest session for this address:', sessionData.sessionId);
          
          // Update URL to reflect latest session (silently via replaceState)
          const newUrl = window.location.origin + window.location.pathname + '?session=' + sessionData.sessionId;
          console.log('Updating URL to latest:', newUrl);
          window.history.replaceState({}, '', newUrl);
          
          // Update urlSessionId for subsequent operations
          urlSessionId = sessionData.sessionId;
        } else if (isAdmin) {
          console.log('🔒 Admin link - showing exact session (no redirect)');
        }
      }
    } else if (urlParamType === 'data') {
      // Legacy: decode from URL (old method)
      console.log('Using legacy data parameter...');
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const encodedData = urlParams.get('data');
        const decoded = JSON.parse(atob(encodedData));
        sessionData = {
          sessionId: urlSessionId || sessionId,
          address: decoded.address,
          shapesData: JSON.stringify(decoded.areas)
        };
      } catch (e) {
        console.error('Error decoding URL data:', e);
        return;
      }
    }
    
    if (!sessionData) {
      console.error('No session data retrieved!');
      alert('Could not load session data. The link may be invalid or expired.');
      return;
    }
    
    console.log('Session data loaded successfully! Proceeding with restoration');
    
    // PHASE 2: Determine the correct parent session
    // If the loaded session has a parent → use THAT parent (keep pointing to original)
    // If the loaded session has NO parent → IT is the original, use it as parent
    if (sessionData.parentSessionId) {
      // This session is a child, keep using its parent (the original)
      parentSessionId = sessionData.parentSessionId;
      console.log('Loaded session is a child. Using its parent as our parent:', parentSessionId);
    } else {
      // This session is the original, use it as parent
      parentSessionId = sessionData.sessionId;
      console.log('Loaded session is the original. Using it as our parent:', parentSessionId);
    }
    
    console.log('Using NEW sessionId:', sessionId, '(Parent:', parentSessionId, ')');
    
    // Set visit number from loaded session + 1 (new browser session)
    if (sessionData.visitNumber) {
      currentVisitNumber = sessionData.visitNumber + 1;
      console.log('Visit number set to:', currentVisitNumber, '(loaded:', sessionData.visitNumber, '+ 1 for new session)');
    } else {
      currentVisitNumber = 2; // If no visit number in data, assume first visit was 1, this is 2
      console.log('No visit number in loaded data - defaulting to visit 2');
    }
    
    // PHASE 3: Load email and marketing opt-in from session data (will check parent if needed)
    if (sessionData.email) {
      userEmail = sessionData.email;
      userMarketingOptIn = sessionData.marketingOptIn !== undefined ? sessionData.marketingOptIn : true;
      saveUserEmail(userEmail, userMarketingOptIn); // Save to localStorage
      console.log('Email loaded from session:', userEmail);
      console.log('Marketing opt-in loaded from session:', userMarketingOptIn);
    } else {
      // Try to load from localStorage (in case parent's email was saved)
      await loadUserEmail();
    }
    
    // PHASE 6: Load emailHasOptedInBefore flag from fetchResult
    if (fetchResult && fetchResult.emailHasOptedInBefore !== undefined) {
      emailHasOptedInBefore = fetchResult.emailHasOptedInBefore;
      console.log('Email has opted in before:', emailHasOptedInBefore);
    }
    
    // Parse shapes data
    let shapesData = [];
    try {
      shapesData = JSON.parse(sessionData.shapesData);
      console.log('Parsed shapes data:', shapesData.length, 'shapes');
    } catch (e) {
      console.error('Error parsing shapes data:', e);
      return;
    }
    
    // Set address and search for it
    if (sessionData.address) {
      console.log('Setting address:', sessionData.address);
      currentAddress = sessionData.address;
      const addressInput = document.getElementById('address-input');
      if (addressInput) {
        addressInput.value = sessionData.address;
      }
      
      // Geocode and center map on address
      console.log('Geocoding address...');
      geocoder.geocode({ address: sessionData.address }, function(results, status) {
        console.log('Geocode result:', status);
        if (status === 'OK' && results[0]) {
          const location = results[0].geometry.location;
          map.setCenter(location);
          map.setZoom(20);
          
          // Hide empty state, show map
          document.getElementById('empty-state').style.display = 'none';
          document.getElementById('map-container').style.display = 'block';
          
          console.log('Map centered, restoring shapes in 500ms...');
          
          // Restore all shapes
          setTimeout(() => {
            restoreShapesFromData(shapesData);
          }, 500);
        } else {
          console.error('Geocoding failed:', status);
          alert('Could not locate address: ' + sessionData.address);
        }
      });
    }
  }
  
  // NEW: Restore from localStorage (page refresh)
  function restoreFromLocalStorage() {
    if (!localStorageData) {
      console.error('No localStorage data to restore!');
      return;
    }
    
    console.log('📦 Restoring from localStorage:', localStorageData);
    
    // Set address
    currentAddress = localStorageData.address;
    const addressInput = document.getElementById('address-input');
    if (addressInput) {
      addressInput.value = localStorageData.address;
    }
    
    // Set area counter
    if (localStorageData.areaCounter) {
      areaCounter = localStorageData.areaCounter;
    }
    
    // Geocode and center map on address
    console.log('Geocoding address:', localStorageData.address);
    geocoder.geocode({ address: localStorageData.address }, function(results, status) {
      console.log('Geocode result:', status);
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        map.setCenter(location);
        map.setZoom(20);
        
        // Hide empty state, show map
        document.getElementById('empty-state').style.display = 'none';
        document.getElementById('map-container').style.display = 'block';
        
        console.log('Map centered, restoring shapes...');
        
        // Restore all shapes
        setTimeout(() => {
          restoreShapesFromData(localStorageData.areas);
          
          // Hide instruction box after successful restoration
          setTimeout(() => {
            hideInstructionBox();
          }, 1500);
          
          console.log('✅ localStorage restoration complete!');
        }, 500);
      } else {
        console.error('Geocoding failed:', status);
        alert('Could not locate saved address: ' + localStorageData.address);
      }
    });
  }
  
  function restoreShapesFromData(shapesData) {
    console.log('Restoring', shapesData.length, 'shapes');
    
    shapesData.forEach(shapeData => {
      let shape = null;
      
      if (shapeData.type === 'rectangle') {
        // Reconstruct rectangle
        if (shapeData.bounds && shapeData.bounds.corners) {
          // Polygon-based rectangle
          const corners = shapeData.bounds.corners.map(c => new google.maps.LatLng(c.lat, c.lng));
          shape = new google.maps.Polygon({
            paths: corners,
            strokeColor: '#dc2626',
            strokeOpacity: 0.8,
            strokeWeight: 3,
            fillColor: '#dc2626',
            fillOpacity: 0.15,
            editable: false,
            draggable: false,
            clickable: true,
            map: map,
            zIndex: 1
          });
        } else if (shapeData.bounds && shapeData.bounds.ne && shapeData.bounds.sw) {
          // Rectangle-based (legacy)
          const bounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(shapeData.bounds.sw.lat, shapeData.bounds.sw.lng),
            new google.maps.LatLng(shapeData.bounds.ne.lat, shapeData.bounds.ne.lng)
          );
          shape = new google.maps.Rectangle({
            bounds: bounds,
            strokeColor: '#dc2626',
            strokeOpacity: 0.8,
            strokeWeight: 3,
            fillColor: '#dc2626',
            fillOpacity: 0.15,
            editable: false,
            draggable: false,
            clickable: true,
            map: map,
            zIndex: 1
          });
        }
      } else if (shapeData.type === 'circle') {
        // Reconstruct circle
        shape = new google.maps.Circle({
          center: new google.maps.LatLng(shapeData.center.lat, shapeData.center.lng),
          radius: shapeData.radius,
          strokeColor: '#2563eb',
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillColor: '#2563eb',
          fillOpacity: 0.15,
          editable: false,
          draggable: false,
          clickable: true,
          map: map,
          zIndex: 1
        });
      }
      
      if (shape) {
        // Create label for the shape (just the number, like original)
        let labelPosition;
        let labelColor;
        
        if (shapeData.type === 'rectangle') {
          // Get center of rectangle
          if (typeof shape.getPath === 'function') {
            // Polygon-based rectangle
            const bounds = new google.maps.LatLngBounds();
            shape.getPath().forEach(function(latLng) {
              bounds.extend(latLng);
            });
            labelPosition = bounds.getCenter();
          } else {
            // Rectangle-based
            labelPosition = shape.getBounds().getCenter();
          }
          labelColor = '#dc2626'; // Red for rectangles
        } else if (shapeData.type === 'circle') {
          labelPosition = shape.getCenter();
          labelColor = '#2563eb'; // Blue for circles
        }
        
        // Create the label marker (just the number like original)
        const label = new google.maps.Marker({
          position: labelPosition,
          map: map,
          draggable: true,
          label: {
            text: `${shapeData.id}`,
            color: 'white',
            fontSize: '13px',
            fontWeight: 'bold'
          },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 11,
            fillColor: labelColor,
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2
          }
        });
        
        // Create area object
        const area = {
          id: shapeData.id || areaCounter++,
          shape: shape,
          label: label,
          type: shapeData.type,
          customName: shapeData.customName || null,
          depth: shapeData.depth || 3,
          rotation: shapeData.rotation || 0,
          measurements: shapeData.measurements || {}
        };
        
        // Add click listeners to shape and label
        google.maps.event.addListener(shape, 'click', function() {
          selectShape(area);
        });
        
        google.maps.event.addListener(label, 'click', function() {
          selectShape(area);
        });
        
        google.maps.event.addListener(label, 'dragstart', function() {
          if (selectedArea !== area) selectShape(area);
        });
        
        google.maps.event.addListener(label, 'drag', function() {
          // Move the shape with the label
          moveShapeToLabel(area);
          if (selectedArea === area) {
            updateHandlePositions();
          }
        });
        
        google.maps.event.addListener(label, 'dragend', function() {
          // Ensure shape is positioned correctly
          moveShapeToLabel(area);
          updateAreaMeasurements(area);
          saveToLocalStorage();
        });
        
        // Add to areas array
        areas.push(area);
        
        // Update measurements
        updateAreaMeasurements(area);
      }
    });
    
    // Update counter
    if (shapesData.length > 0) {
      areaCounter = Math.max(...shapesData.map(s => s.id || 0)) + 1;
    }
    
    // Update UI - this handles everything
    updateUI();
    
    // Save to localStorage
    saveToLocalStorage();
    
    console.log('Restoration complete!', areas.length, 'areas restored');
    
    // PHASE 2: Capture initial state for change detection
    if (isReturnVisit) {
      captureInitialState();
    }
    
    // Post-restoration setup (after a brief delay to ensure all functions are ready)
    setTimeout(() => {
      // Enable drawing tools
      const panBtn = document.getElementById('tool-pan');
      const rectBtn = document.getElementById('tool-rectangle');
      const circleBtn = document.getElementById('tool-circle');
      const zoomInBtn = document.getElementById('zoom-in-btn');
      const zoomOutBtn = document.getElementById('zoom-out-btn');
      
      if (panBtn) panBtn.disabled = false;
      if (rectBtn) rectBtn.disabled = false;
      if (circleBtn) circleBtn.disabled = false;
      if (zoomInBtn) zoomInBtn.disabled = false;
      if (zoomOutBtn) zoomOutBtn.disabled = false;
      
      // Show normal "ready to measure" instruction
      showInstructionBox();
      updateInstruction('addressFound');
      
      // Activate pan tool
      if (panBtn && !panBtn.classList.contains('active')) {
        panBtn.classList.add('active');
        activeTool = 'pan';
        const mapContainer = document.getElementById('map-container');
        if (mapContainer) mapContainer.classList.add('cursor-pan');
      }
      
      console.log('Post-restoration setup complete - all tools enabled, instructions showing');
      
      // PHASE 2: Update button text if this is a return visit
      if (isReturnVisit) {
        const emailBtnText = document.getElementById('email-btn-text');
        if (emailBtnText) {
          emailBtnText.textContent = 'Email Updated Estimate';
          console.log('Button text updated to "Email Updated Estimate"');
        }
      }
      
      // Hide loading overlay
      const overlay = document.getElementById('restoration-overlay');
      if (overlay) {
        overlay.style.display = 'none';
      }
      
      // OPTION A: MILESTONE 1 - Immediate save on restoration with view_only source
      console.log('📌 MILESTONE: Restoration complete - saving immediately with view_only source');
      hasLoggedFirstChange = false; // Reset flag for this session
      captureAndSendData(false, userEmail);
    }, 100);
  }
  
  function enableDrawingTools() {
    const panBtn = document.getElementById('tool-pan');
    const rectBtn = document.getElementById('tool-rectangle');
    const circleBtn = document.getElementById('tool-circle');
    const zoomInBtn = document.getElementById('zoom-in-btn');
    const zoomOutBtn = document.getElementById('zoom-out-btn');
    
    if (panBtn) panBtn.disabled = false;
    if (rectBtn) rectBtn.disabled = false;
    if (circleBtn) circleBtn.disabled = false;
    if (zoomInBtn) zoomInBtn.disabled = false;
    if (zoomOutBtn) zoomOutBtn.disabled = false;
  }
  
  function disableDrawingTools() {
    const panBtn = document.getElementById('tool-pan');
    const rectBtn = document.getElementById('tool-rectangle');
    const circleBtn = document.getElementById('tool-circle');
    const zoomInBtn = document.getElementById('zoom-in-btn');
    const zoomOutBtn = document.getElementById('zoom-out-btn');
    const mapContainer = document.getElementById('map-container');
    
    if (panBtn) {
      panBtn.disabled = true;
      panBtn.classList.remove('active');
    }
    if (rectBtn) {
      rectBtn.disabled = true;
      rectBtn.classList.remove('active');
    }
    if (circleBtn) {
      circleBtn.disabled = true;
      circleBtn.classList.remove('active');
    }
    if (zoomInBtn) zoomInBtn.disabled = true;
    if (zoomOutBtn) zoomOutBtn.disabled = true;
    
    // Remove cursor classes
    if (mapContainer) {
      mapContainer.classList.remove('cursor-pan', 'cursor-crosshair');
    }
    
    // Reset active tool
    activeTool = null;
  }
  
  function loadGoogleMaps() {
    if (window.google && window.google.maps) {
      initCalculator();
      return;
    }
    
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places,geometry&callback=initMulchCalculator`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
  
  window.initMulchCalculator = function() {
    initCalculator();
  };
  
  function initCalculator() {
    geocoder = new google.maps.Geocoder();
    
    // Check if we need to restore from URL
    if (isRestoringFromURL) {
      console.log('Auto-starting for restoration...');
      
      // Calculator screen is already visible in satellite mode
      // No need to hide start screen as it's handled by main section
      
      if (isMobile) {
        document.body.classList.add('calculator-active');
      }
      
      // Initialize map first, then restore session
      const mapDiv = document.getElementById('map');
      if (!map) {
        map = new google.maps.Map(mapDiv, {
          center: { lat: 39.8283, lng: -98.5795 }, // US center as default
          zoom: 4,
          mapTypeId: 'satellite',
          tilt: 0,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false,
          draggableCursor: 'grab',
          draggingCursor: 'grabbing',
          gestureHandling: 'greedy'
        });
        
        // Add click listener to deselect shapes when clicking on map
        google.maps.event.addListener(map, 'click', function(e) {
          if (!drawingMode && selectedArea) {
            deselectShape();
          }
        });
      }
      
      // Trigger restoration after a short delay to ensure map is ready
      setTimeout(function() {
        console.log('Triggering restoration...');
        restoreSessionFromURL();
      }, 1000);
    } else if (isRestoringFromLocalStorage && localStorageData) {
      // NEW: Restore from localStorage (page refresh)
      console.log('🔄 Restoring from localStorage...');
      
      if (isMobile) {
        document.body.classList.add('calculator-active');
      }
      
      // Initialize map first
      const mapDiv = document.getElementById('map');
      if (!map) {
        map = new google.maps.Map(mapDiv, {
          center: { lat: 39.8283, lng: -98.5795 }, // US center as default
          zoom: 4,
          mapTypeId: 'satellite',
          tilt: 0,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false,
          draggableCursor: 'grab',
          draggingCursor: 'grabbing',
          gestureHandling: 'greedy'
        });
        
        // Add click listener to deselect shapes when clicking on map
        google.maps.event.addListener(map, 'click', function(e) {
          if (!drawingMode && selectedArea) {
            deselectShape();
          }
        });
      }
      
      // Restore after short delay
      setTimeout(function() {
        console.log('Triggering localStorage restoration...');
        restoreFromLocalStorage();
      }, 1000);
    }
    
    const addressInput = document.getElementById('address-input');
    const zoomInBtn = document.getElementById('zoom-in-btn');
    const zoomOutBtn = document.getElementById('zoom-out-btn');
    const toolBtns = document.querySelectorAll('.tool-btn');
    const clearAllBtn = document.getElementById('clear-all-btn');
    
    // Initially disable all drawing tools until address is entered
    disableDrawingTools();
    
    // Google Places Autocomplete
    autocomplete = new google.maps.places.Autocomplete(addressInput, {
      types: ['address'],
      componentRestrictions: { country: 'us' }
    });
    
    autocomplete.addListener('place_changed', function() {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const newAddress = place.formatted_address || document.getElementById('address-input').value;
        
        // PHASE 3: Detect address changes and create new session
        const isAddressChange = currentAddress && currentAddress !== newAddress && areas.length > 0;
        
        if (isAddressChange) {
          console.log('Address change detected! Old:', currentAddress, 'New:', newAddress);
          console.log('Saving current work and creating new session...');
          
          // ENHANCEMENT 1: Capture whether this was a return visit BEFORE resetting
          const wasReturnVisit = isReturnVisit;
          
          // Save current work to old session
          captureAndSendData(false, userEmail);
          
          // OPTION A: MILESTONE 3 - Create new sessionId but preserve parentSessionId for same visit number
          const previousParentSessionId = parentSessionId; // Save it before any changes
          
          // Create brand new session for this address
          sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
          localStorage.setItem('calcSessionId', sessionId);
          
          // KEEP parentSessionId to maintain same visit number (don't clear it!)
          if (wasReturnVisit && previousParentSessionId) {
            parentSessionId = previousParentSessionId; // Preserve for same visit
            isReturnVisit = true; // Keep return visit status
            console.log('📌 MILESTONE: Address change - new session but keeping same visit number via parentSessionId:', parentSessionId);
          } else {
            parentSessionId = null;
            isReturnVisit = false;
          }
          
          // ENHANCEMENT 1: Mark as address change session and track if it was from return
          isAddressChangeSession = wasReturnVisit ? 'return' : 'new';
          
          // Reset first change flag for new address session
          hasLoggedFirstChange = false;
          
          // Clear email (new project = re-enter email)
          clearUserEmail();
          
          // Clear all shapes from map
          areas.forEach(area => {
            if (area.shape) area.shape.setMap(null);
            if (area.label) area.label.setMap(null);
          });
          areas = [];
          areaCounter = 0;
          
          // Clear sidebar and update UI
          updateUI();
          
          // Reset initial state for new session
          initialShapesState = null;
          
          console.log('New session created:', sessionId);
        }
        
        currentAddress = newAddress; // Store address
        showMap(place.geometry.location);
        
        // OPTION A: MILESTONE 3 - Immediate save after address change
        if (isAddressChange) {
          console.log('📌 MILESTONE: Address change complete - saving immediately with address_change source');
          performAutoSave();
        } else {
          // ENHANCEMENT #2: Save address immediately (even with 0 shapes)
          saveToLocalStorage();
          performAutoSave();
        }
        console.log('📍 Address captured:', newAddress);
        
        // Only show location found instruction if it's a different address
        if (newAddress !== lastAddress) {
          lastAddress = newAddress;
          
          // Show "Location found" instruction
          updateInstruction('locationFound');
          
          // After 2 seconds, transition to "Ready to measure" instruction
          setTimeout(() => {
            updateInstruction('addressFound');
          }, 2000);
        }
        
        // MOBILE: Collapse drawer after address is entered
        if (isMobile && drawerState === 'expanded') {
          const sidebar = document.getElementById('estimate-sidebar');
          if (sidebar) {
            drawerState = 'collapsed';
            sidebar.classList.remove('drawer-expanded');
            sidebar.classList.add('drawer-collapsed');
          }
        }
      }
    });
    
    // Also support Enter key
    addressInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        findAddress();
      }
    });
    
    // ENHANCEMENT: Auto-select address text when clicking on input with existing address
    addressInput.addEventListener('focus', function() {
      // Only select if there's content and it's not the placeholder
      if (this.value && this.value.trim() !== '') {
        // Use setTimeout to ensure selection happens after focus
        setTimeout(() => {
          this.select();
        }, 50);
      }
    });
    
    // Also handle click event for better UX (some browsers handle focus differently)
    addressInput.addEventListener('click', function() {
      if (this.value && this.value.trim() !== '' && !this.selectionStart && !this.selectionEnd) {
        this.select();
      }
    });
    
    // Zoom button controls
    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function() {
        if (this.disabled || !map) return;
        const currentZoom = map.getZoom();
        map.setZoom(currentZoom + 1);
      });
    }
    
    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function() {
        if (this.disabled || !map) return;
        const currentZoom = map.getZoom();
        map.setZoom(currentZoom - 1);
      });
    }
    
    // Per-area depth bubble selector (delegated event listener)
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('depth-bubble')) {
        const areaId = parseInt(e.target.dataset.areaId);
        const depth = parseInt(e.target.dataset.depth);
        
        // Find the area and update its depth
        const area = areas.find(a => a.id === areaId);
        if (area) {
          area.depth = depth;
          
          // Get the card element
          const card = e.target.closest('.area-card');
          
          // Update active state on all bubbles in this card
          const allBubbles = card.querySelectorAll('.depth-bubble');
          allBubbles.forEach(bubble => {
            bubble.classList.remove('active');
          });
          e.target.classList.add('active');
          
          // Recalculate measurements for this area
          updateAreaMeasurements(area);
          
          // Update only the material value in this specific card (no rebuild)
          const materialValue = card.querySelector('.measurement-value.highlight');
          if (materialValue) {
            materialValue.textContent = `${area.measurements.cubicYards} cu yd`;
          }
          
          // Update totals only (fast operation)
          updateTotals();
          updateDrawerTotals();
          
          // PHASE 3.3: Trigger auto-save after depth changed
          saveToLocalStorage();
          triggerAutoSave();
        }
      }
    });
    
    // Edit area name (delegated event listener)
    document.addEventListener('click', function(e) {
      if (e.target.closest('.edit-name-btn')) {
        const btn = e.target.closest('.edit-name-btn');
        const areaId = parseInt(btn.dataset.areaId);
        const card = btn.closest('.area-card');
        const displayEl = card.querySelector('.area-name-display');
        const inputEl = card.querySelector('.area-name-input');
        
        // Toggle to edit mode
        displayEl.style.display = 'none';
        inputEl.style.display = 'block';
        inputEl.focus();
        inputEl.select();
        btn.classList.add('editing');
      }
    });
    
    // Handle name input blur (save on blur)
    document.addEventListener('blur', function(e) {
      if (e.target.classList.contains('area-name-input')) {
        const inputEl = e.target;
        const areaId = parseInt(inputEl.dataset.areaId);
        const newName = inputEl.value.trim();
        
        // Find the area and update its name
        const area = areas.find(a => a.id === areaId);
        if (area && newName) {
          area.customName = newName;
        } else if (area && !newName) {
          // Revert to default if empty
          inputEl.value = area.customName;
        }
        
        // Toggle back to display mode
        const card = inputEl.closest('.area-card');
        const displayEl = card.querySelector('.area-name-display');
        const editBtn = card.querySelector('.edit-name-btn');
        
        displayEl.textContent = area.customName;
        displayEl.style.display = 'inline';
        inputEl.style.display = 'none';
        editBtn.classList.remove('editing');
        
        // PHASE 3.3: Trigger auto-save after name changed
        saveToLocalStorage();
        triggerAutoSave();
      }
    }, true);
    
    // Handle name input Enter key (save on Enter)
    document.addEventListener('keydown', function(e) {
      if (e.target.classList.contains('area-name-input') && e.key === 'Enter') {
        e.target.blur(); // Trigger blur to save
      }
    });
    
    // Tool buttons
    toolBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        // Don't allow interaction if button is disabled
        if (this.disabled) return;
        
        const tool = this.dataset.tool;
        
        if (activeTool === tool) {
          return; // Already active
        } else {
          activateTool(tool, this);
        }
      });
    });
    
    // Clear all
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', clearAllAreas);
    }
    
    // Delete tool button
    const deleteToolBtn = document.getElementById('delete-tool-btn');
    if (deleteToolBtn) {
      deleteToolBtn.addEventListener('click', deleteSelectedShape);
    }
    
    // Email Me This button
    const emailMeBtn = document.getElementById('email-me-btn');
    if (emailMeBtn) {
      emailMeBtn.addEventListener('click', function() {
        showEmailModal();
      });
    }
    
    // Email modal interactions
    const emailModal = document.getElementById('email-modal');
    const emailModalClose = document.getElementById('email-modal-close');
    const emailCancelBtn = document.getElementById('email-cancel-btn');
    const emailSendBtn = document.getElementById('email-send-btn');
    const emailInputField = document.getElementById('email-input-field');
    
    if (emailModalClose) {
      emailModalClose.addEventListener('click', hideEmailModal);
    }
    
    if (emailCancelBtn) {
      emailCancelBtn.addEventListener('click', hideEmailModal);
    }
    
    if (emailSendBtn) {
      emailSendBtn.addEventListener('click', function() {
        const emailInputField = document.getElementById('email-input-field');
        const marketingOptinCheckbox = document.getElementById('email-marketing-optin');
        
        const email = emailInputField.value.trim();
        if (!email) {
          alert('Please enter your email address');
          return;
        }
        if (!isValidEmail(email)) {
          alert('Please enter a valid email address');
          return;
        }
        
        // PHASE 6: Get marketing opt-in state - force TRUE if email has opted in before
        let marketingOptIn;
        if (emailHasOptedInBefore) {
          marketingOptIn = true; // Force TRUE if email has opted in before
        } else {
          marketingOptIn = marketingOptinCheckbox ? marketingOptinCheckbox.checked : false;
        }
        
        // Save the email and marketing opt-in
        saveUserEmail(email, marketingOptIn);
        
        // Send data with email and marketing opt-in
        captureAndSendData(true, email, marketingOptIn);
        hideEmailModal();
        // Keep email input filled (don't clear)
      });
    }
    
    // Close modal on overlay click
    if (emailModal) {
      emailModal.addEventListener('click', function(e) {
        if (e.target === emailModal || e.target.classList.contains('email-modal-overlay')) {
          hideEmailModal();
        }
      });
    }
    
    // Enter key to send
    if (emailInputField) {
      emailInputField.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          emailSendBtn.click();
        }
      });
      
      // PHASE 6: Check opt-in status when email changes
      let emailCheckTimeout;
      emailInputField.addEventListener('input', async function(e) {
        const email = e.target.value.trim();
        
        // Debounce the check (wait 500ms after user stops typing)
        clearTimeout(emailCheckTimeout);
        emailCheckTimeout = setTimeout(async () => {
          if (email && isValidEmail(email)) {
            const modal = document.getElementById('email-modal');
            const optinContainer = modal ? modal.querySelector('.email-modal-optin') : null;
            const marketingOptinCheckbox = modal ? modal.querySelector('#email-marketing-optin') : null;
            
            const hasOptedIn = await checkEmailOptInStatus(email);
            emailHasOptedInBefore = hasOptedIn;
            
            if (hasOptedIn && optinContainer) {
              // Hide checkbox if email has opted in before
              optinContainer.style.display = 'none';
            } else if (optinContainer) {
              // Show checkbox if email hasn't opted in
              optinContainer.style.display = 'block';
              if (marketingOptinCheckbox) {
                marketingOptinCheckbox.checked = userMarketingOptIn;
              }
            }
          }
        }, 500);
      });
    }
    
    // PHASE 3: Exit Warning Modal interactions
    const exitWarningModal = document.getElementById('exit-warning-modal');
    const exitModalCancel = document.getElementById('exit-modal-cancel');
    const exitModalJustExit = document.getElementById('exit-modal-just-exit');
    const exitModalEmailExit = document.getElementById('exit-modal-email-exit');
    const exitEmailInput = document.getElementById('exit-email-input');
    
    if (exitModalCancel) {
      exitModalCancel.addEventListener('click', hideExitWarningModal);
    }
    
    if (exitModalJustExit) {
      exitModalJustExit.addEventListener('click', handleExitWithoutEmail);
    }
    
    if (exitModalEmailExit) {
      exitModalEmailExit.addEventListener('click', handleExitWithEmail);
    }
    
    // Close exit modal on overlay click
    if (exitWarningModal) {
      exitWarningModal.addEventListener('click', function(e) {
        if (e.target === exitWarningModal || e.target.classList.contains('exit-modal-overlay')) {
          hideExitWarningModal();
        }
      });
    }
    
    // Enter key to send email and exit
    if (exitEmailInput) {
      exitEmailInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          exitModalEmailExit.click();
        }
      });
      
      // PHASE 6: Check opt-in status when email changes
      let exitEmailCheckTimeout;
      exitEmailInput.addEventListener('input', async function(e) {
        const email = e.target.value.trim();
        
        // Debounce the check (wait 500ms after user stops typing)
        clearTimeout(exitEmailCheckTimeout);
        exitEmailCheckTimeout = setTimeout(async () => {
          if (email && isValidEmail(email)) {
            const modal = document.getElementById('exit-warning-modal');
            const optinContainer = modal ? modal.querySelector('.exit-modal-optin') : null;
            const marketingOptinCheckbox = modal ? modal.querySelector('#exit-marketing-optin') : null;
            
            const hasOptedIn = await checkEmailOptInStatus(email);
            emailHasOptedInBefore = hasOptedIn;
            
            if (hasOptedIn && optinContainer) {
              // Hide checkbox if email has opted in before
              optinContainer.style.display = 'none';
            } else if (optinContainer) {
              // Show checkbox if email hasn't opted in
              optinContainer.style.display = 'block';
              if (marketingOptinCheckbox) {
                marketingOptinCheckbox.checked = userMarketingOptIn;
              }
            }
          }
        }, 500);
      });
    }
    
    // Undo button
    const undoBtn = document.getElementById('undo-btn');
    if (undoBtn) {
      undoBtn.addEventListener('click', undo);
    }
    
    // Show initial instruction
    showInstructionBox();
    updateInstruction('initial');
    
    // PHASE 3.3: Start periodic auto-save system
    startPeriodicAutoSave();
    console.log('✅ Auto-save system initialized (2s debounce + 30s periodic backup)');
  }
  
  function activateTool(tool, btn) {
    document.querySelectorAll('.tool-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    activeTool = tool;
    
    const mapContainer = document.getElementById('map-container');
    
    mapContainer.classList.remove('cursor-pan', 'cursor-crosshair');
    
    if (tool === 'pan') {
      mapContainer.classList.add('cursor-pan');
      if (map) {
        stopDrawing();
        map.setOptions({ 
          draggable: true,
          draggableCursor: 'grab',
          draggingCursor: 'grabbing'
        });
        // Update instruction when switching to pan tool
        if (areas.length > 0) {
          updateInstruction('shapePlaced');
        } else {
          updateInstruction('addressFound');
        }
      }
    } else if (tool === 'rectangle' || tool === 'circle') {
      mapContainer.classList.add('cursor-crosshair');
      if (map) {
        map.setOptions({ 
          draggable: isMobile ? true : false, // Keep draggable on mobile for tap-to-place + pan
          draggableCursor: 'crosshair',
          draggingCursor: 'crosshair'
        });
        startDrawing();
      }
    }
  }
  
  function findAddress() {
    const address = document.getElementById('address-input').value.trim();
    
    if (!address) {
      return;
    }
    
    geocoder.geocode({ address: address }, function(results, status) {
      if (status === 'OK') {
        const location = results[0].geometry.location;
        const newAddress = results[0].formatted_address;
        
        // PHASE 3: Detect address changes and create new session
        const isAddressChange = currentAddress && currentAddress !== newAddress && areas.length > 0;
        
        if (isAddressChange) {
          console.log('Address change detected! Old:', currentAddress, 'New:', newAddress);
          console.log('Saving current work and creating new session...');
          
          // ENHANCEMENT 1: Capture whether this was a return visit BEFORE resetting
          const wasReturnVisit = isReturnVisit;
          
          // Save current work to old session
          captureAndSendData(false, userEmail);
          
          // OPTION A: MILESTONE 3 - Create new sessionId but preserve parentSessionId for same visit number
          const previousParentSessionId = parentSessionId; // Save it before any changes
          
          // Create brand new session for this address
          sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
          localStorage.setItem('calcSessionId', sessionId);
          
          // KEEP parentSessionId to maintain same visit number (don't clear it!)
          if (wasReturnVisit && previousParentSessionId) {
            parentSessionId = previousParentSessionId; // Preserve for same visit
            isReturnVisit = true; // Keep return visit status
            console.log('📌 MILESTONE: Address change - new session but keeping same visit number via parentSessionId:', parentSessionId);
          } else {
            parentSessionId = null;
            isReturnVisit = false;
          }
          
          // ENHANCEMENT 1: Mark as address change session and track if it was from return
          isAddressChangeSession = wasReturnVisit ? 'return' : 'new';
          
          // Reset first change flag for new address session
          hasLoggedFirstChange = false;
          
          // Clear email (new project = re-enter email)
          clearUserEmail();
          
          // Clear all shapes from map
          areas.forEach(area => {
            if (area.shape) area.shape.setMap(null);
            if (area.label) area.label.setMap(null);
          });
          areas = [];
          areaCounter = 0;
          
          // Clear sidebar and update UI
          updateUI();
          
          // Reset initial state for new session
          initialShapesState = null;
          
          console.log('New session created:', sessionId);
        }
        
        currentAddress = newAddress; // Store address
        showMap(location);
        
        // OPTION A: MILESTONE 3 - Immediate save after address change
        if (isAddressChange) {
          console.log('📌 MILESTONE: Address change complete - saving immediately with address_change source');
          performAutoSave();
        } else {
          // ENHANCEMENT #2: Save address immediately (even with 0 shapes)
          saveToLocalStorage();
          performAutoSave();
        }
        console.log('📍 Address captured:', newAddress);
        
        // Only show location found instruction if it's a different address
        if (newAddress !== lastAddress) {
          lastAddress = newAddress;
          
          // Show "Location found" instruction
          updateInstruction('locationFound');
          
          // After 2 seconds, transition to "Ready to measure" instruction
          setTimeout(() => {
            updateInstruction('addressFound');
          }, 2000);
        }
        
        // MOBILE: Collapse drawer after address is entered
        if (isMobile && drawerState === 'expanded') {
          const sidebar = document.getElementById('estimate-sidebar');
          if (sidebar) {
            drawerState = 'collapsed';
            sidebar.classList.remove('drawer-expanded');
            sidebar.classList.add('drawer-collapsed');
          }
        }
      }
    });
  }
  
  function showMap(location) {
    const mapContainer = document.getElementById('map-container');
    const emptyState = document.getElementById('empty-state');
    const mapDiv = document.getElementById('map');
    
    if (!map) {
      map = new google.maps.Map(mapDiv, {
        center: location,
        zoom: 21,
        mapTypeId: 'satellite',
        tilt: 0,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false,
        draggableCursor: 'grab',
        draggingCursor: 'grabbing',
        gestureHandling: 'greedy'
      });
      
      const maxZoomService = new google.maps.MaxZoomService();
      maxZoomService.getMaxZoomAtLatLng(location, function(result) {
        if (result.status === 'OK') {
          const actualMax = result.zoom;
          map.setOptions({ maxZoom: actualMax });
        }
      });
      
      google.maps.event.addListener(map, 'click', function(e) {
        if (!drawingMode && selectedArea) {
          deselectShape();
        }
      });
      
      if (activeTool === 'pan') {
        mapContainer.classList.add('cursor-pan');
      }
    } else {
      map.setCenter(location);
      map.setZoom(21);
      
      const maxZoomService = new google.maps.MaxZoomService();
      maxZoomService.getMaxZoomAtLatLng(location, function(result) {
        if (result.status === 'OK') {
          const actualMax = result.zoom;
          map.setOptions({ maxZoom: actualMax });
        }
      });
    }
    
    emptyState.style.display = 'none';
    mapContainer.style.display = 'block';
    
    // Enable drawing tools now that map is available
    enableDrawingTools();
    
    // Activate pan tool by default
    const panToolBtn = document.getElementById('tool-pan');
    if (panToolBtn) {
      activateTool('pan', panToolBtn);
    }
    
    // Show instruction
    showInstructionBox();
    updateInstruction('addressFound');
    
    // PHASE 3: Capture initial state for fresh sessions
    // This ensures hasChangesBeenMade() works for both fresh and return sessions
    if (!initialShapesState && !isRestoringFromURL) {
      captureInitialState();
      console.log('Initial state captured for fresh session (empty state)');
    }
    
    // MOBILE: Show drawer in collapsed state when map is shown (after address entry)
    if (isMobile) {
      const sidebar = document.getElementById('estimate-sidebar');
      if (sidebar && drawerState === 'hidden') {
        drawerState = 'collapsed';
        sidebar.classList.remove('drawer-hidden', 'drawer-expanded');
        sidebar.classList.add('drawer-collapsed');
        console.log('📱 Drawer set to collapsed state after address entry');
      }
    }
    
    if (activeTool && activeTool !== 'pan') {
      startDrawing();
    }
  }
  
  function startDrawing() {
    if (!map || !activeTool || activeTool === 'pan') return;
    
    drawingMode = true;
    
    // Update instruction based on tool
    if (activeTool === 'circle') {
      updateInstruction('circleSelected');
    } else if (activeTool === 'rectangle') {
      updateInstruction('rectangleSelected');
    }
    
    if (mouseDownListener) google.maps.event.removeListener(mouseDownListener);
    if (mouseMoveListener) google.maps.event.removeListener(mouseMoveListener);
    if (mouseUpListener) google.maps.event.removeListener(mouseUpListener);
    
    mouseDownListener = google.maps.event.addListener(map, 'mousedown', handleMouseDown);
    mouseMoveListener = google.maps.event.addListener(map, 'mousemove', handleMouseMove);
    mouseUpListener = google.maps.event.addListener(map, 'mouseup', handleMouseUp);
  }
  
  function stopDrawing() {
    drawingMode = false;
    isDrawing = false;
    startPoint = null;
    
    if (mouseDownListener) {
      google.maps.event.removeListener(mouseDownListener);
      mouseDownListener = null;
    }
    if (mouseMoveListener) {
      google.maps.event.removeListener(mouseMoveListener);
      mouseMoveListener = null;
    }
    if (mouseUpListener) {
      google.maps.event.removeListener(mouseUpListener);
      mouseUpListener = null;
    }
    
    if (previewShape) {
      previewShape.setMap(null);
      previewShape = null;
    }
  }
  
  function handleMouseDown(event) {
    if (!drawingMode || !activeTool) return;
    
    // Mobile: Track touch start for tap vs drag detection
    if (isTouchDevice) {
      touchStartPos = event.latLng;
      touchStartTime = Date.now();
      hasMoved = false;
      return;
    }
    
    // Desktop: Start drag-to-draw
    isDrawing = true;
    startPoint = event.latLng;
    
    createPreviewShape(startPoint, startPoint);
  }
  
  function handleMouseMove(event) {
    // Mobile: Track if finger moved (for tap vs drag detection)
    if (isTouchDevice && touchStartPos) {
      const moveDistance = google.maps.geometry.spherical.computeDistanceBetween(touchStartPos, event.latLng);
      // If moved more than 5 meters, consider it a drag
      if (moveDistance > 5) {
        hasMoved = true;
      }
      return;
    }
    
    // Desktop: Update preview shape during drag
    if (!isDrawing || !startPoint) return;
    
    const currentPoint = event.latLng;
    updatePreviewShape(startPoint, currentPoint);
  }
  
  function handleMouseUp(event) {
    // Mobile: Only create shape if it was a tap (not a drag)
    if (isTouchDevice && touchStartPos) {
      const touchDuration = Date.now() - touchStartTime;
      
      // It's a tap if: didn't move AND took less than 300ms
      if (!hasMoved && touchDuration < 300) {
        createDefaultSizedShape(event.latLng);
      }
      
      // Reset tap detection
      touchStartPos = null;
      touchStartTime = 0;
      hasMoved = false;
      return;
    }
    
    // Desktop: Finish drawing shape
    if (!isDrawing || !startPoint) return;
    
    const endPoint = event.latLng;
    
    const distance = google.maps.geometry.spherical.computeDistanceBetween(startPoint, endPoint);
    
    if (distance > 1) {
      createFinalShape(startPoint, endPoint, activeTool);
    }
    
    if (previewShape) {
      previewShape.setMap(null);
      previewShape = null;
    }
    
    isDrawing = false;
    startPoint = null;
  }
  
  function createPreviewShape(start, end) {
    if (previewShape) {
      previewShape.setMap(null);
    }
    
    if (activeTool === 'rectangle') {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(start);
      bounds.extend(end);
      
      previewShape = new google.maps.Rectangle({
        bounds: bounds,
        map: map,
        fillColor: '#5CA85C',
        fillOpacity: 0.2,
        strokeWeight: 2,
        strokeColor: '#5CA85C',
        editable: false,
        draggable: false,
        clickable: false
      });
    } else if (activeTool === 'circle') {
      const radius = google.maps.geometry.spherical.computeDistanceBetween(start, end) / 2;
      
      previewShape = new google.maps.Circle({
        center: start,
        radius: Math.max(radius, 1),
        map: map,
        fillColor: '#5CA85C',
        fillOpacity: 0.2,
        strokeWeight: 2,
        strokeColor: '#5CA85C',
        editable: false,
        draggable: false,
        clickable: false
      });
    }
  }
  
  function updatePreviewShape(start, end) {
    if (!previewShape) {
      createPreviewShape(start, end);
      return;
    }
    
    if (activeTool === 'rectangle') {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(start);
      bounds.extend(end);
      previewShape.setBounds(bounds);
    } else if (activeTool === 'circle') {
      const distance = google.maps.geometry.spherical.computeDistanceBetween(start, end);
      const radius = distance / 2;
      previewShape.setRadius(Math.max(radius, 1));
    }
  }
  
  function createDefaultSizedShape(centerPoint) {
    let firstPoint, secondPoint;
    
    if (activeTool === 'rectangle') {
      // Default: 12ft length x 8ft width
      const lengthMeters = 12 * 0.3048; // 12 feet = 3.6576 meters
      const widthMeters = 8 * 0.3048;   // 8 feet = 2.4384 meters
      
      const halfLength = lengthMeters / 2;
      const halfWidth = widthMeters / 2;
      
      // Calculate bounds by offsetting from center
      const ne = google.maps.geometry.spherical.computeOffset(
        google.maps.geometry.spherical.computeOffset(centerPoint, halfLength, 0),
        halfWidth, 90
      );
      const sw = google.maps.geometry.spherical.computeOffset(
        google.maps.geometry.spherical.computeOffset(centerPoint, halfLength, 180),
        halfWidth, -90
      );
      
      firstPoint = ne;
      secondPoint = sw;
    } else if (activeTool === 'circle') {
      // CHANGE #6 - Mobile default: 18ft diameter = 9ft radius
      const radiusMeters = (isMobile ? 9 : 6) * 0.3048;
      
      firstPoint = centerPoint;
      // Second point sets the radius
      secondPoint = google.maps.geometry.spherical.computeOffset(centerPoint, radiusMeters, 90);
    }
    
    if (firstPoint && secondPoint) {
      createFinalShape(firstPoint, secondPoint, activeTool);
      
      // Immediately select the shape to show handles for resizing
      const newShape = areas[areas.length - 1];
      selectShape(newShape);
      
      // Note: Drawing tool will auto-deselect to pan tool (handled in createFinalShape)
    }
  }
  
  function createFinalShape(firstPoint, secondPoint, shapeType) {
    // Deselect any currently selected shape before creating new one
    if (selectedArea) {
      deselectShape();
    }
    
    areaCounter++;
    let shapeObject, label;
    
    if (shapeType === 'rectangle') {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(firstPoint);
      bounds.extend(secondPoint);
      
      shapeObject = new google.maps.Rectangle({
        bounds: bounds,
        map: map,
        fillColor: '#dc2626',
        fillOpacity: 0.35,
        strokeWeight: 3,
        strokeColor: '#dc2626',
        editable: false,
        draggable: false,
        clickable: true
      });
      
      label = new google.maps.Marker({
        position: bounds.getCenter(),
        map: map,
        draggable: true,
        label: {
          text: `${areaCounter}`,
          color: 'white',
          fontSize: '13px',
          fontWeight: 'bold'
        },
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 11,
          fillColor: '#dc2626',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2
        }
      });
      
    } else if (shapeType === 'circle') {
      const diameter = google.maps.geometry.spherical.computeDistanceBetween(firstPoint, secondPoint);
      const radius = diameter / 2;
      
      shapeObject = new google.maps.Circle({
        center: firstPoint,
        radius: radius,
        map: map,
        fillColor: '#2563eb',
        fillOpacity: 0.35,
        strokeWeight: 3,
        strokeColor: '#2563eb',
        editable: false,
        draggable: false,
        clickable: true
      });
      
      label = new google.maps.Marker({
        position: firstPoint,
        map: map,
        draggable: true,
        label: {
          text: `${areaCounter}`,
          color: 'white',
          fontSize: '13px',
          fontWeight: 'bold'
        },
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 11,
          fillColor: '#2563eb',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2
        }
      });
    }
    
    const areaData = {
      id: areaCounter,
      type: shapeType,
      shape: shapeObject,
      label: label,
      customName: `${shapeType === 'rectangle' ? 'Rectangle' : 'Circle'} ${areaCounter}`, // Default editable name
      depth: 3, // Default depth in inches
      rotation: shapeType === 'rectangle' ? 0 : undefined // Store rotation for rectangles
    };
    areas.push(areaData);
    
    // Track for undo
    addToUndoHistory({
      type: 'add',
      areaData: areaData
    });
    
    // CHANGE #7 - Make entire shape clickable to select
    google.maps.event.addListener(shapeObject, 'click', function() {
      selectShape(areaData);
    });
    
    // Also make label clickable to select
    google.maps.event.addListener(label, 'click', function() {
      selectShape(areaData);
    });
    
    google.maps.event.addListener(label, 'dragstart', function() {
      // Capture state before moving
      preModificationState = captureShapeState(areaData);
    });
    
    google.maps.event.addListener(label, 'drag', function() {
      moveShapeToLabel(areaData);
      if (selectedArea === areaData) {
        updateHandlePositions();
      }
    });
    
    google.maps.event.addListener(label, 'dragend', function() {
      moveShapeToLabel(areaData);
      updateAreaMeasurements(areaData);
      
      // Add to undo history
      if (preModificationState) {
        addToUndoHistory({
          type: 'modify',
          previousState: preModificationState,
          description: 'move'
        });
        preModificationState = null;
      }
      
      // PHASE 3.3: Trigger auto-save after shape moved
      saveToLocalStorage();
      triggerAutoSave();
    });
    
    updateAreaMeasurements(areaData);
    updateUI();
    
    // PHASE 3.3: Trigger auto-save after shape created
    triggerAutoSave();
    
    // Update instruction to show shape was placed
    if (areas.length > 0) {
      updateInstruction('shapePlaced');
    }
    
    // Auto-deselect drawing tool and switch to pan tool for better UX
    const panToolBtn = document.getElementById('tool-pan');
    if (panToolBtn && (activeTool === 'rectangle' || activeTool === 'circle')) {
      activateTool('pan', panToolBtn);
    }
  }
  
  function moveShapeToLabel(areaData) {
    const newCenter = areaData.label.getPosition();
    
    if (areaData.type === 'rectangle') {
      const isRotated = areaData.rotation && areaData.rotation !== 0;
      
      if (isRotated) {
        // For rotated rectangles (polygons), move all corners
        const path = areaData.shape.getPath();
        const coords = path.getArray();
        
        // Calculate old center
        const latSum = coords[0].lat() + coords[1].lat() + coords[2].lat() + coords[3].lat();
        const lngSum = coords[0].lng() + coords[1].lng() + coords[2].lng() + coords[3].lng();
        const oldCenter = new google.maps.LatLng(latSum / 4, lngSum / 4);
        
        const latDiff = newCenter.lat() - oldCenter.lat();
        const lngDiff = newCenter.lng() - oldCenter.lng();
        
        // Move all corners
        const newCorners = coords.map(coord => 
          new google.maps.LatLng(coord.lat() + latDiff, coord.lng() + lngDiff)
        );
        
        areaData.shape.setPath(newCorners);
      } else {
        // For non-rotated rectangles
        const bounds = areaData.shape.getBounds();
        const oldCenter = bounds.getCenter();
        
        const latDiff = newCenter.lat() - oldCenter.lat();
        const lngDiff = newCenter.lng() - oldCenter.lng();
        
        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();
        
        const newNE = new google.maps.LatLng(ne.lat() + latDiff, ne.lng() + lngDiff);
        const newSW = new google.maps.LatLng(sw.lat() + latDiff, sw.lng() + lngDiff);
        
        const newBounds = new google.maps.LatLngBounds(newSW, newNE);
        areaData.shape.setBounds(newBounds);
      }
    } else {
      // For circles, update center and move handle if selected
      const oldCenter = areaData.shape.getCenter();
      areaData.shape.setCenter(newCenter);
      
      // Update radius line and handle if circle is selected and has one
      if (selectedArea === areaData && radiusLine && resizeHandles.length > 0) {
        const handle = resizeHandles[0]; // Circle only has one resize handle
        const oldHandlePos = handle.getPosition();
        
        // Calculate the offset/bearing from old center to handle
        const heading = google.maps.geometry.spherical.computeHeading(oldCenter, oldHandlePos);
        const distance = google.maps.geometry.spherical.computeDistanceBetween(oldCenter, oldHandlePos);
        
        // Apply same offset to new center
        const newHandlePos = google.maps.geometry.spherical.computeOffset(newCenter, distance, heading);
        handle.setPosition(newHandlePos);
        
        // Update radius line
        radiusLine.setPath([newCenter, newHandlePos]);
      }
    }
  }
  
  function updateAreaMeasurements(areaData) {
    let areaSquareFeet, lengthFeet, widthFeet, diameter;
    
    if (areaData.type === 'rectangle') {
      let ne, sw, nw, se, center;
      
      // Check if shape is a Polygon (has getPath) or Rectangle (has getBounds)
      const isPolygon = typeof areaData.shape.getPath === 'function';
      
      if (isPolygon) {
        // Get corners from polygon
        const path = areaData.shape.getPath();
        const coords = path.getArray();
        nw = coords[0];
        ne = coords[1];
        se = coords[2];
        sw = coords[3];
        
        // Calculate center
        const latSum = nw.lat() + ne.lat() + se.lat() + sw.lat();
        const lngSum = nw.lng() + ne.lng() + se.lng() + sw.lng();
        center = new google.maps.LatLng(latSum / 4, lngSum / 4);
      } else {
        // Get from bounds (Rectangle)
        const bounds = areaData.shape.getBounds();
        ne = bounds.getNorthEast();
        sw = bounds.getSouthWest();
        nw = new google.maps.LatLng(ne.lat(), sw.lng());
        se = new google.maps.LatLng(sw.lat(), ne.lng());
        center = bounds.getCenter();
      }
      
      const lengthMeters = google.maps.geometry.spherical.computeDistanceBetween(nw, sw);
      const widthMeters = google.maps.geometry.spherical.computeDistanceBetween(sw, se);
      
      lengthFeet = lengthMeters * 3.28084;
      widthFeet = widthMeters * 3.28084;
      areaSquareFeet = lengthFeet * widthFeet;
      
      areaData.label.setPosition(center);
    } else {
      const radiusMeters = areaData.shape.getRadius();
      const radiusFeet = radiusMeters * 3.28084;
      diameter = radiusFeet * 2;
      areaSquareFeet = Math.PI * radiusFeet * radiusFeet;
      
      areaData.label.setPosition(areaData.shape.getCenter());
    }
    
    const depthFeet = areaData.depth / 12;
    const volumeCubicFeet = areaSquareFeet * depthFeet;
    const volumeCubicYards = volumeCubicFeet / 27;
    const cubicYardsRounded = Math.round(volumeCubicYards * 10) / 10;
    
    areaData.measurements = {
      length: lengthFeet,
      width: widthFeet,
      diameter: diameter,
      area: areaSquareFeet,
      cubicYards: cubicYardsRounded
    };
    
    updateUI();
  }
  
  function updateUI() {
    const areasCount = document.getElementById('areas-count');
    const emptyMessage = document.getElementById('empty-message');
    const areasList = document.getElementById('areas-list');
    const totalEstimate = document.getElementById('total-estimate');
    const clearAllBtn = document.getElementById('clear-all-btn');
    const emailMeBtn = document.getElementById('email-me-btn');
    
    // PHASE 4: Show/hide admin badge
    const adminBadge = document.getElementById('admin-badge');
    if (adminBadge) {
      adminBadge.style.display = isAdminMode ? 'inline-flex' : 'none';
    }
    
    areasCount.textContent = `for ${areas.length} area${areas.length !== 1 ? 's' : ''} measured`;
    
    if (areas.length === 0) {
      emptyMessage.style.display = 'flex';
      areasList.style.display = 'none';
      totalEstimate.style.display = 'none';
      if (emailMeBtn) emailMeBtn.style.display = 'none';
    } else {
      emptyMessage.style.display = 'none';
      areasList.style.display = 'block';
      totalEstimate.style.display = 'block';
      clearAllBtn.style.display = 'flex';
      
      // PHASE 4: Disable buttons in admin mode
      if (isAdminMode) {
        clearAllBtn.disabled = true;
        clearAllBtn.style.opacity = '0.5';
        clearAllBtn.style.cursor = 'not-allowed';
        if (emailMeBtn) {
          emailMeBtn.style.display = 'none';
        }
      } else {
        clearAllBtn.disabled = false;
        clearAllBtn.style.opacity = '1';
        clearAllBtn.style.cursor = 'pointer';
        if (emailMeBtn) {
          emailMeBtn.style.display = 'flex';
        }
      }
      
      renderAreasList();
      updateTotals();
      
      saveToLocalStorage();
    }
    
    updateDrawerState();
    updateDrawerTotals();
  }
  
  function renderAreasList() {
    const areasList = document.getElementById('areas-list');
    areasList.innerHTML = '';
    
    areas.forEach(areaData => {
      const m = areaData.measurements;
      const isCircle = areaData.type === 'circle';
      
      const card = document.createElement('div');
      card.className = 'area-card';
      card.dataset.areaId = areaData.id;
      
      let measurementsHTML = '';
      if (isCircle) {
        measurementsHTML = `
          <div class="measurement-item">
            <div class="measurement-label">Diameter</div>
            <div class="measurement-value">${m.diameter.toFixed(1)} ft</div>
          </div>
          <div class="measurement-item">
            <div class="measurement-label">Material</div>
            <div class="measurement-value highlight">${m.cubicYards} cu yd</div>
          </div>
          <div class="measurement-item">
            <div class="measurement-label">Area</div>
            <div class="measurement-value">${m.area.toFixed(0)} sq ft</div>
          </div>
        `;
      } else {
        measurementsHTML = `
          <div class="measurement-item">
            <div class="measurement-label">Length</div>
            <div class="measurement-value">${m.length.toFixed(1)} ft</div>
          </div>
          <div class="measurement-item">
            <div class="measurement-label">Width</div>
            <div class="measurement-value">${m.width.toFixed(1)} ft</div>
          </div>
          <div class="measurement-item">
            <div class="measurement-label">Area</div>
            <div class="measurement-value">${m.area.toFixed(0)} sq ft</div>
          </div>
          <div class="measurement-item">
            <div class="measurement-label">Material</div>
            <div class="measurement-value highlight">${m.cubicYards} cu yd</div>
          </div>
        `;
      }
      
      
      card.innerHTML = `
        <div class="area-card-header">
          <div class="area-card-title">
            <div class="area-icon ${areaData.type}">
              ${areaData.id}
            </div>
            <div class="area-card-title-text">
              <h3 class="area-name-display" data-area-id="${areaData.id}">${areaData.customName}</h3>
              <input 
                type="text" 
                class="area-name-input" 
                data-area-id="${areaData.id}" 
                value="${areaData.customName}" 
                style="display: none;"
              >
            </div>
            <button class="edit-name-btn" data-area-id="${areaData.id}" title="Edit name">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </button>
          </div>
          <button class="area-delete-btn" onclick="window.deleteArea(${areaData.id})">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
            </svg>
          </button>
        </div>
        <div class="area-measurements">
          ${measurementsHTML}
        </div>
        <div class="area-depth-control">
          <label class="area-depth-label">Depth</label>
          <div class="depth-bubbles" data-area-id="${areaData.id}">
            ${[1, 2, 3, 4, 5, 6].map(depth => `
              <button 
                class="depth-bubble ${depth === areaData.depth ? 'active' : ''}" 
                data-depth="${depth}"
                data-area-id="${areaData.id}"
              >
                ${depth}"
              </button>
            `).join('')}
          </div>
        </div>
      `;
      
      areasList.appendChild(card);
    });
  }
  
  function updateTotals() {
    let totalArea = 0;
    let totalCubicYards = 0;
    
    areas.forEach(areaData => {
      if (areaData.measurements) {
        totalArea += areaData.measurements.area;
        totalCubicYards += areaData.measurements.cubicYards;
      }
    });
    
    document.getElementById('total-area').textContent = totalArea.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    document.getElementById('total-mulch').textContent = totalCubicYards.toFixed(1);
  }
  
  window.deleteArea = function(areaId) {
    const index = areas.findIndex(a => a.id === areaId);
    if (index === -1) return;
    
    const areaData = areas[index];
    
    // Track for undo before removing
    addToUndoHistory({
      type: 'delete',
      areaData: areaData
    });
    
    if (selectedArea === areaData) {
      deselectShape();
    }
    
    areaData.shape.setMap(null);
    areaData.label.setMap(null);
    areas.splice(index, 1);
    
    updateUI();
    
    // PHASE 3.3: Trigger auto-save after shape deleted
    triggerAutoSave();
  };
  
  function clearAllAreas() {
    // PHASE 4: Block clear all in admin mode
    if (isAdminMode) {
      console.log('Admin mode: Clear all blocked');
      return;
    }
    
    areas.forEach(areaData => {
      areaData.shape.setMap(null);
      areaData.label.setMap(null);
    });
    
    areas = [];
    areaCounter = 0;
    undoHistory = []; // Clear undo history
    
    deselectShape();
    stopDrawing();
    updateUI();
    updateUndoButton();
    
    // Reset instructions based on whether map is visible
    if (map && document.getElementById('map-container').style.display !== 'none') {
      updateInstruction('addressFound');
    } else {
      updateInstruction('initial');
    }
    
    // PHASE 3.3: Trigger auto-save after clear all
    saveToLocalStorage();
    triggerAutoSave();
  }
  
  // UNDO FUNCTIONS
  
  function updateUndoButton() {
    const undoBtn = document.getElementById('undo-btn');
    if (undoBtn) {
      undoBtn.disabled = undoHistory.length === 0;
    }
  }
  
  function captureShapeState(areaData) {
    // Capture current state of a shape for undo
    const state = {
      id: areaData.id,
      type: areaData.type,
      rotation: areaData.rotation
    };
    
    if (areaData.type === 'rectangle') {
      const isPolygon = typeof areaData.shape.getPath === 'function';
      
      if (isPolygon) {
        // Store polygon corners
        const path = areaData.shape.getPath();
        const coords = path.getArray();
        state.corners = coords.map(c => ({ lat: c.lat(), lng: c.lng() }));
      } else {
        // Store rectangle bounds
        const bounds = areaData.shape.getBounds();
        state.bounds = {
          ne: { lat: bounds.getNorthEast().lat(), lng: bounds.getNorthEast().lng() },
          sw: { lat: bounds.getSouthWest().lat(), lng: bounds.getSouthWest().lng() }
        };
      }
    } else if (areaData.type === 'circle') {
      state.center = {
        lat: areaData.shape.getCenter().lat(),
        lng: areaData.shape.getCenter().lng()
      };
      state.radius = areaData.shape.getRadius();
    }
    
    // Store label position
    state.labelPosition = {
      lat: areaData.label.getPosition().lat(),
      lng: areaData.label.getPosition().lng()
    };
    
    return state;
  }
  
  function restoreShapeState(areaData, state) {
    // Restore shape to a previous state
    if (areaData.type === 'rectangle') {
      if (state.corners) {
        // Restore polygon
        const corners = state.corners.map(c => new google.maps.LatLng(c.lat, c.lng));
        
        // Check if already a polygon
        const isPolygon = typeof areaData.shape.getPath === 'function';
        
        if (isPolygon) {
          areaData.shape.setPath(corners);
        } else {
          // Convert to polygon
          areaData.shape.setMap(null);
          areaData.shape = new google.maps.Polygon({
            path: corners,
            map: map,
            fillColor: '#dc2626',
            fillOpacity: 0.35,
            strokeWeight: 3,
            strokeColor: '#dc2626',
            editable: false,
            draggable: false,
            clickable: true,
            zIndex: 1
          });
          
          // Re-add click listener
          google.maps.event.addListener(areaData.shape, 'click', function() {
            selectShape(areaData);
          });
        }
        
        areaData.rotation = state.rotation;
      } else if (state.bounds) {
        // Restore rectangle
        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(state.bounds.sw.lat, state.bounds.sw.lng),
          new google.maps.LatLng(state.bounds.ne.lat, state.bounds.ne.lng)
        );
        
        // Check if currently a polygon
        const isPolygon = typeof areaData.shape.getPath === 'function';
        
        if (isPolygon) {
          // Convert back to rectangle
          areaData.shape.setMap(null);
          areaData.shape = new google.maps.Rectangle({
            bounds: bounds,
            map: map,
            fillColor: '#dc2626',
            fillOpacity: 0.35,
            strokeWeight: 3,
            strokeColor: '#dc2626',
            editable: false,
            draggable: false,
            clickable: true
          });
          
          // Re-add click listener
          google.maps.event.addListener(areaData.shape, 'click', function() {
            selectShape(areaData);
          });
        } else {
          areaData.shape.setBounds(bounds);
        }
        
        areaData.rotation = 0;
      }
    } else if (areaData.type === 'circle') {
      const center = new google.maps.LatLng(state.center.lat, state.center.lng);
      areaData.shape.setCenter(center);
      areaData.shape.setRadius(state.radius);
    }
    
    // Restore label position
    const labelPos = new google.maps.LatLng(state.labelPosition.lat, state.labelPosition.lng);
    areaData.label.setPosition(labelPos);
    
    // Update measurements and handles
    updateAreaMeasurements(areaData);
    if (selectedArea === areaData) {
      updateHandlePositions();
    }
  }
  
  function addToUndoHistory(action) {
    undoHistory.push(action);
    
    // Limit to last 5 actions
    if (undoHistory.length > MAX_UNDO_HISTORY) {
      undoHistory.shift();
    }
    
    updateUndoButton();
  }
  
  function undo() {
    if (undoHistory.length === 0) return;
    
    const action = undoHistory.pop();
    
    if (action.type === 'add') {
      // Undo an addition by removing the shape
      const index = areas.findIndex(a => a.id === action.areaData.id);
      if (index !== -1) {
        const areaData = areas[index];
        
        if (selectedArea === areaData) {
          deselectShape();
        }
        
        areaData.shape.setMap(null);
        areaData.label.setMap(null);
        areas.splice(index, 1);
        
        updateUI();
      }
    } else if (action.type === 'delete') {
      // Undo a deletion by re-adding the shape
      const areaData = action.areaData;
      
      // Re-add to map
      areaData.shape.setMap(map);
      areaData.label.setMap(map);
      
      // Re-add to areas array
      areas.push(areaData);
      
      // Re-add click listeners
      google.maps.event.addListener(areaData.shape, 'click', function() {
        selectShape(areaData);
      });
      
      google.maps.event.addListener(areaData.label, 'click', function() {
        selectShape(areaData);
      });
      
      google.maps.event.addListener(areaData.label, 'dragstart', function() {
        // Capture state before moving
        preModificationState = captureShapeState(areaData);
      });
      
      google.maps.event.addListener(areaData.label, 'drag', function() {
        moveShapeToLabel(areaData);
        if (selectedArea === areaData) {
          updateHandlePositions();
        }
      });
      
      google.maps.event.addListener(areaData.label, 'dragend', function() {
        moveShapeToLabel(areaData);
        updateAreaMeasurements(areaData);
        
        // Add to undo history
        if (preModificationState) {
          addToUndoHistory({
            type: 'modify',
            previousState: preModificationState,
            description: 'move'
          });
          preModificationState = null;
        }
      });
      
      updateUI();
    } else if (action.type === 'modify') {
      // Undo a modification (resize, rotate, move) by restoring previous state
      const areaData = areas.find(a => a.id === action.previousState.id);
      if (areaData) {
        restoreShapeState(areaData, action.previousState);
        updateUI();
      }
    }
    
    updateUndoButton();
    
    // PHASE 3.3: Trigger auto-save after undo
    saveToLocalStorage();
    triggerAutoSave();
  }
  
  // SELECTION AND RESIZE FUNCTIONS
  
  function selectShape(areaData) {
    if (selectedArea) {
      deselectShape();
    }
    
    selectedArea = areaData;
    createResizeHandles();
    
    // Enable delete button when shape is selected
    updateDeleteButton();
    
    // Update instruction based on selected shape type
    if (areaData.type === 'rectangle') {
      updateInstruction('rectangleActive');
    } else if (areaData.type === 'circle') {
      updateInstruction('circleActive');
    }
  }
  
  function deselectShape() {
    if (!selectedArea) return;
    
    selectedArea = null;
    clearResizeHandles();
    
    // Disable delete button when no shape is selected
    updateDeleteButton();
    
    // Update instruction to show shapes can be edited
    if (areas.length > 0) {
      updateInstruction('shapePlaced');
    }
  }
  
  // DELETE TOOL FUNCTIONS
  
  function updateDeleteButton() {
    const deleteBtn = document.getElementById('delete-tool-btn');
    if (deleteBtn) {
      deleteBtn.disabled = !selectedArea;
    }
  }
  
  function deleteSelectedShape() {
    if (!selectedArea || isAdminMode) return;
    
    const areaToDelete = selectedArea;
    
    // Add to undo history BEFORE deleting
    addToUndoHistory({
      type: 'delete',
      areaData: areaToDelete
    });
    
    // Remove from map
    areaToDelete.shape.setMap(null);
    areaToDelete.label.setMap(null);
    
    // Remove from areas array
    const index = areas.indexOf(areaToDelete);
    if (index > -1) {
      areas.splice(index, 1);
    }
    
    // Deselect and clear handles
    deselectShape();
    
    // Switch to pan tool
    const panToolBtn = document.getElementById('tool-pan');
    if (panToolBtn) {
      activateTool('pan', panToolBtn);
    }
    
    // Update UI
    updateUI();
    updateUndoButton();
    updateDrawerState();
    updateDrawerTotals();
    
    // Update instruction
    if (areas.length > 0) {
      updateInstruction('shapePlaced');
    } else {
      updateInstruction('addressFound');
    }
    
    // Trigger auto-save
    saveToLocalStorage();
    triggerAutoSave();
  }
  
  // RESIZE HANDLE FUNCTIONS
  
  function clearResizeHandles() {
    resizeHandles.forEach(handle => handle.setMap(null));
    resizeHandles = [];
    
    if (radiusLine) {
      radiusLine.setMap(null);
      radiusLine = null;
    }
    
    if (rotationHandle) {
      rotationHandle.setMap(null);
      rotationHandle = null;
    }
    
    if (rotationLine) {
      rotationLine.setMap(null);
      rotationLine = null;
    }
  }
  
  function createResizeHandles() {
    if (!selectedArea) return;
    
    clearResizeHandles();
    
    if (selectedArea.type === 'rectangle') {
      createRectangleHandles();
    } else if (selectedArea.type === 'circle') {
      createCircleHandles();
    }
  }
  
  function createRectangleHandles() {
    // Check if shape is a Polygon (has getPath) or Rectangle (has getBounds)
    const isPolygon = typeof selectedArea.shape.getPath === 'function';
    let ne, sw, nw, se;
    
    if (isPolygon) {
      // Get corners from polygon
      const path = selectedArea.shape.getPath();
      const coords = path.getArray();
      nw = coords[0];
      ne = coords[1];
      se = coords[2];
      sw = coords[3];
    } else {
      // Get corners from rectangle bounds
      const bounds = selectedArea.shape.getBounds();
      ne = bounds.getNorthEast();
      sw = bounds.getSouthWest();
      nw = new google.maps.LatLng(ne.lat(), sw.lng());
      se = new google.maps.LatLng(sw.lat(), ne.lng());
    }
    
    const width = google.maps.geometry.spherical.computeDistanceBetween(nw, ne);
    const height = google.maps.geometry.spherical.computeDistanceBetween(nw, sw);
    const minSizeForEdgeHandles = 10;
    
    // Corner handles
    const corners = [
      { pos: ne, type: 'ne' },
      { pos: nw, type: 'nw' },
      { pos: sw, type: 'sw' },
      { pos: se, type: 'se' }
    ];
    
    corners.forEach(corner => {
      // Determine cursor based on corner type
      let cursorClass;
      if (corner.type === 'ne' || corner.type === 'sw') {
        cursorClass = 'nesw-resize';
      } else if (corner.type === 'nw' || corner.type === 'se') {
        cursorClass = 'nwse-resize';
      }
      
      const handle = new google.maps.Marker({
        position: corner.pos,
        map: map,
        draggable: true,
        optimized: false,
        title: cursorClass,
        icon: {
          path: 'M -4,-4 L 4,-4 L 4,4 L -4,4 Z',
          scale: 1.5,
          fillColor: '#5CA85C',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          rotation: (selectedArea.rotation || 0)  // Rotate with the rectangle
        },
        zIndex: 1000
      });
      
      handle.resizeType = 'corner';
      handle.cornerType = corner.type;
      
      google.maps.event.addListener(handle, 'mousedown', function() {
        // Capture state before modification
        preModificationState = captureShapeState(selectedArea);
        // Update instruction for resizing
        updateInstruction('resizing');
      });
      
      google.maps.event.addListener(handle, 'drag', function() {
        resizeRectangleCorner(corner.type, handle.getPosition());
        updateAreaMeasurements(selectedArea);
        updateHandlePositions(); // Move other handles in real-time
      });
      
      google.maps.event.addListener(handle, 'dragend', function() {
        updateAreaMeasurements(selectedArea);
        updateResizeHandles(); // Recreate handles after drag completes (for edge handle visibility)
        
        // Revert instruction to shape selected
        if (selectedArea && selectedArea.type === 'rectangle') {
          updateInstruction('rectangleActive');
        }
        
        // Add to undo history
        if (preModificationState) {
          addToUndoHistory({
            type: 'modify',
            previousState: preModificationState,
            description: 'resize'
          });
          preModificationState = null;
        }
        
        // PHASE 3.3: Trigger auto-save after shape resized
        saveToLocalStorage();
        triggerAutoSave();
      });
      
      resizeHandles.push(handle);
    });
    
    // Edge handles (only if large enough)
    if (width > minSizeForEdgeHandles) {
      const topMid = new google.maps.LatLng(ne.lat(), (ne.lng() + nw.lng()) / 2);
      createEdgeHandle(topMid, 'n');
      
      const bottomMid = new google.maps.LatLng(sw.lat(), (se.lng() + sw.lng()) / 2);
      createEdgeHandle(bottomMid, 's');
    }
    
    if (height > minSizeForEdgeHandles) {
      const leftMid = new google.maps.LatLng((nw.lat() + sw.lat()) / 2, sw.lng());
      createEdgeHandle(leftMid, 'w');
      
      const rightMid = new google.maps.LatLng((ne.lat() + se.lat()) / 2, ne.lng());
      createEdgeHandle(rightMid, 'e');
    }
    
    // Rotation handle - above the top center
    const topCenter = new google.maps.LatLng((ne.lat() + nw.lat()) / 2, (ne.lng() + nw.lng()) / 2);
    const rotationHandlePos = google.maps.geometry.spherical.computeOffset(topCenter, 2, selectedArea.rotation || 0);
    
    rotationHandle = new google.maps.Marker({
      position: rotationHandlePos,
      map: map,
      draggable: true,
      optimized: false,
      title: 'grab',
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 6,
        fillColor: '#5CA85C',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2
      },
      zIndex: 1000
    });
    
    rotationLine = new google.maps.Polyline({
      path: [topCenter, rotationHandlePos],
      map: map,
      strokeColor: '#5CA85C',
      strokeWeight: 2,
      strokeOpacity: 0.6,
      icons: [{
        icon: {
          path: 'M 0,-1 0,1',
          strokeOpacity: 1,
          scale: 2
        },
        offset: '0',
        repeat: '10px'
      }],
      zIndex: 999
    });
    
    google.maps.event.addListener(rotationHandle, 'mousedown', function() {
      // Capture state before modification
      preModificationState = captureShapeState(selectedArea);
      // Update instruction for rotating
      updateInstruction('rotating');
    });
    
    google.maps.event.addListener(rotationHandle, 'drag', function() {
      rotateRectangle(rotationHandle.getPosition());
      updateAreaMeasurements(selectedArea);
      updateHandlePositions();
    });
    
    google.maps.event.addListener(rotationHandle, 'dragend', function() {
      updateAreaMeasurements(selectedArea);
      
      // Revert instruction to shape selected
      if (selectedArea && selectedArea.type === 'rectangle') {
        updateInstruction('rectangleActive');
      }
      
      // Snap rotation handle back to proper position on line
      if (selectedArea && selectedArea.type === 'rectangle') {
        // Check if shape is a Polygon (has getPath) or Rectangle (has getBounds)
        const isPolygon = typeof selectedArea.shape.getPath === 'function';
        let ne, nw;
        
        if (isPolygon) {
          const path = selectedArea.shape.getPath();
          const coords = path.getArray();
          nw = coords[0];
          ne = coords[1];
        } else {
          const bounds = selectedArea.shape.getBounds();
          ne = bounds.getNorthEast();
          const sw = bounds.getSouthWest();
          nw = new google.maps.LatLng(ne.lat(), sw.lng());
        }
        
        const topCenter = new google.maps.LatLng((ne.lat() + nw.lat()) / 2, (ne.lng() + nw.lng()) / 2);
        const correctHandlePos = google.maps.geometry.spherical.computeOffset(topCenter, 2, selectedArea.rotation || 0);
        
        rotationHandle.setPosition(correctHandlePos);
        if (rotationLine) {
          rotationLine.setPath([topCenter, correctHandlePos]);
        }
      }
      
      // Add to undo history
      if (preModificationState) {
        addToUndoHistory({
          type: 'modify',
          previousState: preModificationState,
          description: 'rotate'
        });
        preModificationState = null;
      }
      
      // PHASE 3.3: Trigger auto-save after shape rotated
      saveToLocalStorage();
      triggerAutoSave();
    });
  }
  
  function createEdgeHandle(position, edgeType) {
    // Determine cursor based on edge type
    let cursorClass;
    if (edgeType === 'n' || edgeType === 's') {
      cursorClass = 'ns-resize';
    } else if (edgeType === 'e' || edgeType === 'w') {
      cursorClass = 'ew-resize';
    }
    
    const handle = new google.maps.Marker({
      position: position,
      map: map,
      draggable: true,
      optimized: false,
      title: cursorClass,
      icon: {
        path: 'M -4,-4 L 4,-4 L 4,4 L -4,4 Z',
        scale: 1.5,
        fillColor: '#5CA85C',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2
      },
      zIndex: 1000
    });
    
    handle.resizeType = 'edge';
    handle.edgeType = edgeType;
    
    google.maps.event.addListener(handle, 'mousedown', function() {
      // Capture state before modification
      preModificationState = captureShapeState(selectedArea);
      // Update instruction for resizing
      updateInstruction('resizing');
    });
    
    google.maps.event.addListener(handle, 'drag', function() {
      resizeRectangleEdge(edgeType, handle.getPosition());
      updateAreaMeasurements(selectedArea);
      updateHandlePositions(); // Move other handles in real-time
    });
    
    google.maps.event.addListener(handle, 'dragend', function() {
      updateAreaMeasurements(selectedArea);
      updateResizeHandles(); // Recreate handles after drag completes (for edge handle visibility)
      
      // Revert instruction to shape selected
      if (selectedArea && selectedArea.type === 'rectangle') {
        updateInstruction('rectangleActive');
      }
      
      // Add to undo history
      if (preModificationState) {
        addToUndoHistory({
          type: 'modify',
          previousState: preModificationState,
          description: 'resize'
        });
        preModificationState = null;
      }
      
      // PHASE 3.3: Trigger auto-save after shape resized
      saveToLocalStorage();
      triggerAutoSave();
    });
    
    resizeHandles.push(handle);
  }
  
  function createCircleHandles() {
    const center = selectedArea.shape.getCenter();
    const radius = selectedArea.shape.getRadius();
    
    const handlePos = google.maps.geometry.spherical.computeOffset(center, radius, 90);
    
    const handle = new google.maps.Marker({
      position: handlePos,
      map: map,
      draggable: true,
      optimized: false,
      title: 'ew-resize',
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 6,
        fillColor: '#5CA85C',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2
      },
      zIndex: 1000
    });
    
    handle.resizeType = 'radius';
    
    // Dashed radius line
    radiusLine = new google.maps.Polyline({
      path: [center, handlePos],
      map: map,
      strokeColor: '#5CA85C',
      strokeWeight: 2,
      strokeOpacity: 0.8,
      icons: [{
        icon: {
          path: 'M 0,-1 0,1',
          strokeOpacity: 1,
          scale: 2
        },
        offset: '0',
        repeat: '10px'
      }],
      zIndex: 999
    });
    
    google.maps.event.addListener(handle, 'mousedown', function() {
      // Capture state before modification
      preModificationState = captureShapeState(selectedArea);
      // Update instruction for resizing
      updateInstruction('resizing');
    });
    
    google.maps.event.addListener(handle, 'drag', function() {
      resizeCircleRadius(handle.getPosition());
      updateAreaMeasurements(selectedArea);
    });
    
    google.maps.event.addListener(handle, 'dragend', function() {
      updateAreaMeasurements(selectedArea);
      
      // Revert instruction to circle selected
      if (selectedArea && selectedArea.type === 'circle') {
        updateInstruction('circleActive');
      }
      
      // Add to undo history
      if (preModificationState) {
        addToUndoHistory({
          type: 'modify',
          previousState: preModificationState,
          description: 'resize'
        });
        preModificationState = null;
      }
      
      // PHASE 3.3: Trigger auto-save after circle resized
      saveToLocalStorage();
      triggerAutoSave();
    });
    
    resizeHandles.push(handle);
  }
  
  function resizeRectangleCorner(cornerType, newPos) {
    const isRotated = selectedArea.rotation && selectedArea.rotation !== 0;
    
    if (!isRotated) {
      // Simple bounds-based resize for non-rotated rectangles
      const bounds = selectedArea.shape.getBounds();
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      
      let newNE, newSW;
      
      switch(cornerType) {
        case 'ne':
          newNE = newPos;
          newSW = sw;
          break;
        case 'nw':
          newNE = new google.maps.LatLng(newPos.lat(), ne.lng());
          newSW = new google.maps.LatLng(sw.lat(), newPos.lng());
          break;
        case 'sw':
          newNE = ne;
          newSW = newPos;
          break;
        case 'se':
          newNE = new google.maps.LatLng(ne.lat(), newPos.lng());
          newSW = new google.maps.LatLng(newPos.lat(), sw.lng());
          break;
      }
      
      const newBounds = new google.maps.LatLngBounds(newSW, newNE);
      selectedArea.shape.setBounds(newBounds);
      selectedArea.label.setPosition(newBounds.getCenter());
    } else {
      // For rotated rectangles, project the drag onto local axes
      const path = selectedArea.shape.getPath();
      const coords = path.getArray();
      const nw = coords[0];
      const ne = coords[1];
      const se = coords[2];
      const sw = coords[3];
      
      // Determine opposite corner
      let oppositeCorner;
      switch(cornerType) {
        case 'ne': oppositeCorner = sw; break;
        case 'nw': oppositeCorner = se; break;
        case 'sw': oppositeCorner = ne; break;
        case 'se': oppositeCorner = nw; break;
      }
      
      // Get rotation angle
      const rotation = selectedArea.rotation;
      
      // Calculate vector from opposite corner to new position
      const vectorDistance = google.maps.geometry.spherical.computeDistanceBetween(oppositeCorner, newPos);
      const vectorHeading = google.maps.geometry.spherical.computeHeading(oppositeCorner, newPos);
      
      // Calculate the angle of this vector relative to the rectangle's local axes
      const relativeAngle = vectorHeading - rotation;
      
      // Project onto local axes (width and height)
      const widthProjection = vectorDistance * Math.cos((relativeAngle + 90) * Math.PI / 180);
      const heightProjection = vectorDistance * Math.cos(relativeAngle * Math.PI / 180);
      
      // Use absolute values for dimensions
      const newWidth = Math.abs(widthProjection);
      const newHeight = Math.abs(heightProjection);
      
      // New center is midpoint between opposite corner and new position
      const newCenter = new google.maps.LatLng(
        (oppositeCorner.lat() + newPos.lat()) / 2,
        (oppositeCorner.lng() + newPos.lng()) / 2
      );
      
      // Reconstruct the rotated rectangle
      const halfWidth = newWidth / 2;
      const halfHeight = newHeight / 2;
      
      const newCorners = [
        google.maps.geometry.spherical.computeOffset(
          google.maps.geometry.spherical.computeOffset(newCenter, halfHeight, rotation),
          halfWidth, rotation - 90
        ), // NW
        google.maps.geometry.spherical.computeOffset(
          google.maps.geometry.spherical.computeOffset(newCenter, halfHeight, rotation),
          halfWidth, rotation + 90
        ), // NE
        google.maps.geometry.spherical.computeOffset(
          google.maps.geometry.spherical.computeOffset(newCenter, halfHeight, rotation + 180),
          halfWidth, rotation + 90
        ), // SE
        google.maps.geometry.spherical.computeOffset(
          google.maps.geometry.spherical.computeOffset(newCenter, halfHeight, rotation + 180),
          halfWidth, rotation - 90
        )  // SW
      ];
      
      selectedArea.shape.setPath(newCorners);
      selectedArea.label.setPosition(newCenter);
    }
  }
  
  function resizeRectangleEdge(edgeType, newPos) {
    const isRotated = selectedArea.rotation && selectedArea.rotation !== 0;
    
    if (!isRotated) {
      // Simple bounds-based resize for non-rotated rectangles
      const bounds = selectedArea.shape.getBounds();
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      
      let newNE, newSW;
      
      switch(edgeType) {
        case 'n':
          newNE = new google.maps.LatLng(newPos.lat(), ne.lng());
          newSW = sw;
          break;
        case 's':
          newNE = ne;
          newSW = new google.maps.LatLng(newPos.lat(), sw.lng());
          break;
        case 'e':
          newNE = new google.maps.LatLng(ne.lat(), newPos.lng());
          newSW = sw;
          break;
        case 'w':
          newNE = ne;
          newSW = new google.maps.LatLng(sw.lat(), newPos.lng());
          break;
      }
      
      const newBounds = new google.maps.LatLngBounds(newSW, newNE);
      selectedArea.shape.setBounds(newBounds);
      selectedArea.label.setPosition(newBounds.getCenter());
    } else {
      // For rotated rectangles, calculate new dimension for the dragged edge
      const path = selectedArea.shape.getPath();
      const coords = path.getArray();
      const nw = coords[0];
      const ne = coords[1];
      const se = coords[2];
      const sw = coords[3];
      
      // Get current dimensions
      const currentWidth = google.maps.geometry.spherical.computeDistanceBetween(nw, ne);
      const currentHeight = google.maps.geometry.spherical.computeDistanceBetween(nw, sw);
      
      // Get current center
      const latSum = nw.lat() + ne.lat() + se.lat() + sw.lat();
      const lngSum = nw.lng() + ne.lng() + se.lng() + sw.lng();
      const center = new google.maps.LatLng(latSum / 4, lngSum / 4);
      
      let newWidth = currentWidth;
      let newHeight = currentHeight;
      let newCenter = center;
      
      const rotation = selectedArea.rotation;
      
      // Calculate new dimension based on which edge is being dragged
      switch(edgeType) {
        case 'n':
        case 's': {
          // Changing height
          const oppositeEdge = edgeType === 'n' ? 
            new google.maps.LatLng((se.lat() + sw.lat()) / 2, (se.lng() + sw.lng()) / 2) :
            new google.maps.LatLng((ne.lat() + nw.lat()) / 2, (ne.lng() + nw.lng()) / 2);
          
          newHeight = google.maps.geometry.spherical.computeDistanceBetween(oppositeEdge, newPos);
          newCenter = new google.maps.LatLng(
            (oppositeEdge.lat() + newPos.lat()) / 2,
            (oppositeEdge.lng() + newPos.lng()) / 2
          );
          break;
        }
        case 'e':
        case 'w': {
          // Changing width
          const oppositeEdge = edgeType === 'e' ?
            new google.maps.LatLng((nw.lat() + sw.lat()) / 2, (nw.lng() + sw.lng()) / 2) :
            new google.maps.LatLng((ne.lat() + se.lat()) / 2, (ne.lng() + se.lng()) / 2);
          
          newWidth = google.maps.geometry.spherical.computeDistanceBetween(oppositeEdge, newPos);
          newCenter = new google.maps.LatLng(
            (oppositeEdge.lat() + newPos.lat()) / 2,
            (oppositeEdge.lng() + newPos.lng()) / 2
          );
          break;
        }
      }
      
      // Reconstruct rotated rectangle with new dimensions
      const halfWidth = newWidth / 2;
      const halfHeight = newHeight / 2;
      
      const newCorners = [
        google.maps.geometry.spherical.computeOffset(
          google.maps.geometry.spherical.computeOffset(newCenter, halfHeight, rotation),
          halfWidth, rotation - 90
        ), // NW
        google.maps.geometry.spherical.computeOffset(
          google.maps.geometry.spherical.computeOffset(newCenter, halfHeight, rotation),
          halfWidth, rotation + 90
        ), // NE
        google.maps.geometry.spherical.computeOffset(
          google.maps.geometry.spherical.computeOffset(newCenter, halfHeight, rotation + 180),
          halfWidth, rotation + 90
        ), // SE
        google.maps.geometry.spherical.computeOffset(
          google.maps.geometry.spherical.computeOffset(newCenter, halfHeight, rotation + 180),
          halfWidth, rotation - 90
        )  // SW
      ];
      
      selectedArea.shape.setPath(newCorners);
      selectedArea.label.setPosition(newCenter);
    }
  }
  
  function resizeCircleRadius(handlePos) {
    const center = selectedArea.shape.getCenter();
    const newRadius = google.maps.geometry.spherical.computeDistanceBetween(center, handlePos);
    
    selectedArea.shape.setRadius(newRadius);
    
    if (radiusLine) {
      radiusLine.setPath([center, handlePos]);
    }
  }
  
  function rotateRectangle(handlePos) {
    // Get current rectangle dimensions and center
    let center, width, height, ne, sw, nw, se;
    
    // Check if shape is already a Polygon (has getPath) or Rectangle (has getBounds)
    const isPolygon = typeof selectedArea.shape.getPath === 'function';
    
    if (isPolygon) {
      // Already a polygon
      const path = selectedArea.shape.getPath();
      const coords = path.getArray();
      nw = coords[0];
      ne = coords[1];
      se = coords[2];
      sw = coords[3];
      
      const latSum = nw.lat() + ne.lat() + se.lat() + sw.lat();
      const lngSum = nw.lng() + ne.lng() + se.lng() + sw.lng();
      center = new google.maps.LatLng(latSum / 4, lngSum / 4);
      
      width = google.maps.geometry.spherical.computeDistanceBetween(nw, ne);
      height = google.maps.geometry.spherical.computeDistanceBetween(nw, sw);
    } else {
      // Currently a Rectangle, need to convert to Polygon
      const bounds = selectedArea.shape.getBounds();
      center = bounds.getCenter();
      ne = bounds.getNorthEast();
      sw = bounds.getSouthWest();
      nw = new google.maps.LatLng(ne.lat(), sw.lng());
      se = new google.maps.LatLng(sw.lat(), ne.lng());
      
      width = google.maps.geometry.spherical.computeDistanceBetween(nw, ne);
      height = google.maps.geometry.spherical.computeDistanceBetween(nw, sw);
      
      // Remove the old Rectangle
      selectedArea.shape.setMap(null);
    }
    
    // Calculate rotation angle from center to handle position
    const angle = google.maps.geometry.spherical.computeHeading(center, handlePos);
    
    // Store the rotation
    selectedArea.rotation = angle;
    
    // Create rotated rectangle as polygon
    const halfWidth = width / 2;
    const halfHeight = height / 2;
    
    // Calculate four corners relative to center with rotation
    const corners = [
      google.maps.geometry.spherical.computeOffset(
        google.maps.geometry.spherical.computeOffset(center, halfHeight, angle),
        halfWidth, angle - 90
      ), // NW
      google.maps.geometry.spherical.computeOffset(
        google.maps.geometry.spherical.computeOffset(center, halfHeight, angle),
        halfWidth, angle + 90
      ), // NE
      google.maps.geometry.spherical.computeOffset(
        google.maps.geometry.spherical.computeOffset(center, halfHeight, angle + 180),
        halfWidth, angle + 90
      ), // SE
      google.maps.geometry.spherical.computeOffset(
        google.maps.geometry.spherical.computeOffset(center, halfHeight, angle + 180),
        halfWidth, angle - 90
      )  // SW
    ];
    
    if (isPolygon) {
      // Update existing polygon
      selectedArea.shape.setPath(corners);
    } else {
      // Create new polygon
      const newPolygon = new google.maps.Polygon({
        path: corners,
        map: map,
        fillColor: '#dc2626',
        fillOpacity: 0.35,
        strokeWeight: 3,
        strokeColor: '#dc2626',
        editable: false,
        draggable: false,
        clickable: true,
        zIndex: 1
      });
      
      selectedArea.shape = newPolygon;
      
      // Re-add click listener to select shape - capture areaData reference
      const capturedAreaData = selectedArea;
      google.maps.event.addListener(newPolygon, 'click', function() {
        selectShape(capturedAreaData);
      });
    }
    
    // Update label position
    selectedArea.label.setPosition(center);
    
    // Update rotation handle to stay on line
    const topCenter = new google.maps.LatLng((corners[0].lat() + corners[1].lat()) / 2, (corners[0].lng() + corners[1].lng()) / 2);
    const newRotationHandlePos = google.maps.geometry.spherical.computeOffset(topCenter, 2, angle);
    
    if (rotationHandle) {
      rotationHandle.setPosition(newRotationHandlePos);
    }
    if (rotationLine) {
      rotationLine.setPath([topCenter, newRotationHandlePos]);
    }
  }
  
  function updateResizeHandles() {
    if (!selectedArea) return;
    createResizeHandles();
  }
  
  function updateHandlePositions() {
    if (!selectedArea || selectedArea.type !== 'rectangle') return;
    
    // Check if shape is a Polygon (has getPath) or Rectangle (has getBounds)
    const isPolygon = typeof selectedArea.shape.getPath === 'function';
    let ne, sw, nw, se;
    
    if (isPolygon) {
      // Get corners from polygon
      const path = selectedArea.shape.getPath();
      const coords = path.getArray();
      nw = coords[0];
      ne = coords[1];
      se = coords[2];
      sw = coords[3];
    } else {
      // Get corners from rectangle bounds
      const bounds = selectedArea.shape.getBounds();
      ne = bounds.getNorthEast();
      sw = bounds.getSouthWest();
      nw = new google.maps.LatLng(ne.lat(), sw.lng());
      se = new google.maps.LatLng(sw.lat(), ne.lng());
    }
    
    // Update each handle's position based on its type
    resizeHandles.forEach(handle => {
      if (handle.resizeType === 'corner') {
        // Update icon rotation to match rectangle rotation
        const currentIcon = handle.getIcon();
        handle.setIcon({
          ...currentIcon,
          rotation: (selectedArea.rotation || 0)  // Rotate with the rectangle
        });
        
        switch(handle.cornerType) {
          case 'ne':
            handle.setPosition(ne);
            break;
          case 'nw':
            handle.setPosition(nw);
            break;
          case 'sw':
            handle.setPosition(sw);
            break;
          case 'se':
            handle.setPosition(se);
            break;
        }
      } else if (handle.resizeType === 'edge') {
        switch(handle.edgeType) {
          case 'n':
            handle.setPosition(new google.maps.LatLng((ne.lat() + nw.lat()) / 2, (ne.lng() + nw.lng()) / 2));
            break;
          case 's':
            handle.setPosition(new google.maps.LatLng((se.lat() + sw.lat()) / 2, (se.lng() + sw.lng()) / 2));
            break;
          case 'e':
            handle.setPosition(new google.maps.LatLng((ne.lat() + se.lat()) / 2, (ne.lng() + se.lng()) / 2));
            break;
          case 'w':
            handle.setPosition(new google.maps.LatLng((nw.lat() + sw.lat()) / 2, (nw.lng() + sw.lng()) / 2));
            break;
        }
      }
    });
    
    // Update rotation handle and line
    if (rotationHandle && rotationLine) {
      const topCenter = new google.maps.LatLng((ne.lat() + nw.lat()) / 2, (ne.lng() + nw.lng()) / 2);
      const rotationHandlePos = google.maps.geometry.spherical.computeOffset(topCenter, 2, selectedArea.rotation || 0);
      rotationHandle.setPosition(rotationHandlePos);
      rotationLine.setPath([topCenter, rotationHandlePos]);
    }
  }
  
  // PHASE 3.3: Visibility Change Listener (Most Reliable)
  // Triggers when user switches tabs, minimizes window, or switches apps
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      // Page is hidden - user switching tabs or minimizing
      console.log('👁️ Visibility change: Page hidden - auto-saving...');
      // ENHANCEMENT #2: Save if there are unsaved changes and an address
      if (hasUnsavedChanges && currentAddress) {
        performAutoSave();
      }
    }
  });
  
  // PHASE 3.3: Window Blur Listener (Additional Coverage)
  // Triggers when window loses focus
  window.addEventListener('blur', function() {
    console.log('💨 Window blur: Lost focus - auto-saving...');
    // ENHANCEMENT #2: Save if there are unsaved changes and an address
    if (hasUnsavedChanges && currentAddress) {
      performAutoSave();
    }
  });
  
  // PHASE 3.3: Simplified beforeunload (Final Fallback Only)
  // Note: This is unreliable on mobile, but kept as last resort
  window.addEventListener('beforeunload', function(e) {
    // Final fallback save attempt
    // ENHANCEMENT #2: Save if there are unsaved changes and an address
    if (hasUnsavedChanges && currentAddress) {
      console.log('⚠️ beforeunload: Final fallback save attempt');
      performAutoSave();
    }
    // Note: We don't use synchronous XHR or sendBeacon here anymore
    // because the auto-save system already handles saves reliably
  });
  
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeSession();
      loadGoogleMaps();
    });
  } else {
    initializeSession();
    loadGoogleMaps();
  }
})();